import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import Sidebar from "../components/layout/Sidebar";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import tourTbc from "../abis/tourTbc.json";
import swal from "sweetalert";
import Modal from "react-modal";
import {
  authRequestNbGet,
  sendFileRequest,
  sendRequest,
  refreshToken,
  assetUrl,
  validateEmail,
  vIndiaphone,
  validateAadhar,
  vpancard,
  validatePassport,
  alphanumeric,
  mandsCheck,
  calcAgeFromDob,
  allLetter,
  toTitleCase,
  validateInternationalId,
} from "../utils/helpers";
import { privateDocumentUrl } from "../services/api";
import DatePickerField from "../components/common/DatePickerField";
import countries from "../data/countries.json";
import Context from "../context/AppContext";
import Web3 from "web3";
import networks from "../data/networks.json";
import { buildTourAccess, calculateRedemption } from "../utils/tourEligibility";

// t_id_u_id_p_id_id_id_timestamp
// t_4_u_6_p_1_2_3_timestamp

const TBC_NETWORK = {
  CHAIN_ID: 10791,
  CHAIN_ID_HEX: "0x2a27",
  NAME: "TrustBitcoin Mainnet",
  SYMBOL: "TBC",
  RPC: "https://rpc.trustbitcoin.io",
  EXPLORER: "https://scan.trustbitcoin.io",
};

const TRAVEL_REDEEM_CONTRACT = tourTbc?.CONTRACT;

const DocumentsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const tourdata = location.state?.tour || null;
  const [coPassengers, setCoPassengers] = useState([{ id: 1 }]);
  const [previews, setPreviews] = useState({});
  const [photos, setPhotos] = useState({});
  const [documentType, setDocumentType] = useState([]);
  const [tour, setTour] = useState({});
  const [myTourRows, setMyTourRows] = useState([]);
  const [tourAccessReady, setTourAccessReady] = useState(false);
  const accessDeniedRef = useRef(false);
  const [savedPassengers, setSavedPassengers] = useState([]);
  const [docNumbers, setDocNumbers] = useState({});
  const [passengerTraveler, setPassengerTraveler] = useState({});
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmPayload, setConfirmPayload] = useState(null);
  const [detailSaved, setDetailSaved] = useState(false);
  const fetchedRef = useRef(false);
  const prefillRef = useRef(false);
  const { slug } = useParams();
  const { account, provider, onConnect, user } = useContext(Context);
  const [airports, setAirports] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({}); // fieldErrors[passengerId]?.firstName
  const [docErrors, setDocErrors] = useState({}); // docErrors[passengerId]?.[docId] = {number, front, back}
  const [photoErrors, setPhotoErrors] = useState({}); // photoErrors[passengerId]
  const selectedNetwork = networks[1];

  const [showNetworkPopup, setShowNetworkPopup] = useState(false);
  const [payAmount, setPayAmount] = useState("1"); // default 1 token
  const payLoading = false;
  const [showPaymentPopup, setShowPaymentPopup] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [pendingSubmit, setPendingSubmit] = useState(null);

  const [showRedeemPopup, setShowRedeemPopup] = useState(false);
  const [redeemLoading, setRedeemLoading] = useState(false);

  const [successRedeemHash, setSuccessRedeemHash] = useState("");

  const [showTransactionLoader, setShowTransactionLoader] = useState(false);
  const [dropDownPassenger, setDropDownPassenger] = useState([]);
  const [transactionLoader, setTransactionLoader] = useState({
    title: "Sign Transaction",
    heading: "Waiting for Confirmation",
    message: "Please sign the transaction via your wallet.",
    txHash: "",
  });

  const [saveLoading, setSaveLoading] = useState(false);
  const [documentLoading, setDocumentLoading] = useState({});
  const setDocLoading = (passengerId, docId, side, value) => {
  setDocumentLoading((prev) => ({
    ...prev,
    [passengerId]: {
      ...(prev[passengerId] || {}),
      [docId]: {
        ...(prev[passengerId]?.[docId] || {}),
        [side]: value,
      },
    },
  }));
};

  useEffect(() => {
    (async () => {
      const res = await authRequestNbGet(
        "me/travelers/all?pagination_type=0&limit=1",
      );
      if (res.status === 200 || res.message === "sucess") {
        setDropDownPassenger(res.data);
      }
    })();
  }, []);
  const updateTransactionLoader = ({
    title,
    heading,
    message,
    txHash = "",
  }) => {
    setTransactionLoader({
      title: title || "Processing Transaction",

      heading: heading || "Please Wait",

      message: message || "Your transaction is being processed.",

      txHash: txHash || "",
    });

    setShowTransactionLoader(true);
  };

  const getWalletProvider = () => {
    if (provider && typeof provider.request === "function") {
      return provider;
    }

    if (
      provider?.currentProvider &&
      typeof provider.currentProvider.request === "function"
    ) {
      return provider.currentProvider;
    }

    if (window?.ethereum && typeof window.ethereum.request === "function") {
      return window.ethereum;
    }

    throw new Error(
      "Wallet provider was not found. Please reconnect your wallet.",
    );
  };

  const ensureTBCNetwork = async () => {
    const walletProvider = getWalletProvider();

    let currentChainId = await walletProvider.request({
      method: "eth_chainId",
    });

    currentChainId = String(currentChainId).toLowerCase();

    if (currentChainId === TBC_NETWORK.CHAIN_ID_HEX.toLowerCase()) {
      return true;
    }

    updateTransactionLoader({
      title: "Switch Network",
      heading: "Switching to Trust Bitcoin Mainnet",
      message: "Please approve the network switch in your wallet.",
    });

    try {
      await walletProvider.request({
        method: "wallet_switchEthereumChain",

        params: [
          {
            chainId: TBC_NETWORK.CHAIN_ID_HEX,
          },
        ],
      });
    } catch (error) {
      const errorCode = Number(error?.code || error?.data?.originalError?.code);

      if (errorCode === 4902) {
        await walletProvider.request({
          method: "wallet_addEthereumChain",

          params: [
            {
              chainId: TBC_NETWORK.CHAIN_ID_HEX,

              chainName: TBC_NETWORK.NAME,

              nativeCurrency: {
                name: TBC_NETWORK.SYMBOL,
                symbol: TBC_NETWORK.SYMBOL,
                decimals: 18,
              },

              rpcUrls: [TBC_NETWORK.RPC],

              blockExplorerUrls: [TBC_NETWORK.EXPLORER],
            },
          ],
        });

        await walletProvider.request({
          method: "wallet_switchEthereumChain",

          params: [
            {
              chainId: TBC_NETWORK.CHAIN_ID_HEX,
            },
          ],
        });
      } else {
        throw error;
      }
    }

    const finalChainId = await walletProvider.request({
      method: "eth_chainId",
    });

    if (
      String(finalChainId).toLowerCase() !==
      TBC_NETWORK.CHAIN_ID_HEX.toLowerCase()
    ) {
      throw new Error("Please switch your wallet to Trust Bitcoin Mainnet.");
    }

    return true;
  };

  const getBlockchainErrorMessage = (error) => {
    // console.error("Blockchain error:", error);

    const code = Number(
      error?.code || error?.data?.code || error?.data?.originalError?.code,
    );

    const rawMessage =
      error?.data?.message ||
      error?.data?.originalError?.message ||
      error?.cause?.message ||
      error?.reason ||
      error?.message ||
      "";

    const message = String(rawMessage);

    if (
      code === 4001 ||
      /user rejected/i.test(message) ||
      /user denied/i.test(message)
    ) {
      return "Transaction cancelled. You rejected the request in your wallet.";
    }

    if (/insufficient funds/i.test(message)) {
      return "Insufficient TBC balance to pay the network gas fee.";
    }

    if (/execution reverted/i.test(message)) {
      const cleaned = message.replace(/^.*execution reverted:?\s*/i, "").trim();

      return (
        cleaned ||
        "The redemption transaction was rejected by the smart contract."
      );
    }

    if (/chain/i.test(message) && /switch|network/i.test(message)) {
      return "Please switch your wallet to Trust Bitcoin Mainnet.";
    }

    if (message) {
      return message;
    }

    return "Something went wrong while processing the blockchain transaction.";
  };

  const currentTour = useMemo(() => {
    if (!tour?.id && !tourdata) return {};

    return {
      ...(tourdata || {}),
      ...(tour || {}),
      eligibility: tour?.eligibility || tourdata?.eligibility || {},
    };
  }, [tour, tourdata]);

  const amt = Number(currentTour?.business || 0);

  const tourAccess = useMemo(
    () => buildTourAccess({ tour: currentTour, myTours: myTourRows }),
    [currentTour, myTourRows],
  );

  const alreadyApplied = Number(tourAccess?.eligibility?.alreadyApplied || 0);
  const maxPassengers = Math.max(
    Number(tourAccess?.eligibility?.maxPassengers || 0),
    alreadyApplied,
  );
  const applicationOpen = Boolean(tourAccess?.applicationOpen);
  const bookingStarted = Boolean(tourAccess?.booking?.bookingStarted);
  const isBookingUpcoming = Boolean(tourAccess?.booking?.isUpcoming);

  const newPassengerCount = Math.max(coPassengers.length - alreadyApplied, 0);

  const redemption = useMemo(
    () =>
      calculateRedemption({
        tour: currentTour,
        passengerCount: newPassengerCount,
      }),
    [currentTour, newPassengerCount],
  );

  const requiredPoints = redemption.pointsRequired;
  const requiredPointUnitsPerPassenger = redemption.requiredUnits;
  const totalPointsToRedeem = redemption.totalPointsToRedeem;
  const totalRequiredPoints = requiredPoints * newPassengerCount;
  const availableEquivalentPoints = redemption.availableEquivalentPoints;
  const hasEnoughRedeemBalance = redemption.hasEnoughRedeemBalance;

  useEffect(() => {
    if (!tourAccessReady || !currentTour?.id || accessDeniedRef.current) return;
    if (tourAccess.canOpenDocuments) return;

    accessDeniedRef.current = true;

    swal(
      "Tour Booking Unavailable",
      tourAccess.reason || "You are not eligible to access this tour form.",
      "warning",
    ).then(() => {
      navigate("/dashboard", { replace: true });
    });
  }, [
    tourAccessReady,
    currentTour?.id,
    tourAccess.canOpenDocuments,
    tourAccess.reason,
    navigate,
  ]);


  const isPassengerPaid = (passenger) => {
    // console.log("passenger::passenger", passenger);
    const txHash = String(passenger?.transaction_hash || "").trim();

    const txStatus = Number(passenger?.transaction_status);

    return txHash !== "" && txStatus === 1;
  };

  const unpaidPassengers = coPassengers.filter(
    (passenger) => !isPassengerPaid(passenger),
  );

  const unpaidPassengerCount = unpaidPassengers.length;

  const allPassengersPaid =
    coPassengers.length > 0 && unpaidPassengerCount === 0;

  const formatPoints = (value) => {
    const number = Number(value || 0);

    return Number.isInteger(number)
      ? String(number)
      : number.toFixed(0).replace(/\.?0+$/, "");
  };

  const savedUser = sessionStorage.getItem("user");
  if (!savedUser || savedUser === "undefined") {
    navigate("/login", { replace: true });
  }

  useEffect(() => {
    if (!tour) {
      navigate("/dashboard", { replace: true });
    }
  }, [tour, navigate]);

  const shouldSkipDoc = (docId, docName, isMinor, nationality) => {
    const id = Number(docId);
    const nat = (nationality || "").toLowerCase().trim();
    const isIndian = nat === "india";

    if (isMinor && id === 3) return true;
    if (!isIndian && (id === 2 || id === 3)) return true;

    return false;
  };

  useEffect(() => {
    coPassengers.forEach((p) => {
      const nat = (p.nationality || "").toLowerCase().trim();
      const isIndian = nat === "india";
      if (!isIndian) {
        setDocNumbers((prev) => {
          const copy = { ...prev };
          if (copy[p.id]) {
            delete copy[p.id][2];
            delete copy[p.id][3];
          }
          return copy;
        });
        setPreviews((prev) => {
          const copy = { ...prev };
          if (copy[p.id]) {
            delete copy[p.id][2];
            delete copy[p.id][3];
          }
          return copy;
        });
      }
    });
  }, [coPassengers]);

  const validateDocNumberByType = (docTypeId, docNo) => {
    const v = (docNo || "").trim();
    if (!v) return false;

    switch (Number(docTypeId)) {
      case 1: // Passport
        return validatePassport(v);
      case 2: // Aadhaar
        return validateAadhar(v);
      case 3: // PAN
        return vpancard(v);
      case 4: // Bank Statement
      case 5: // ITR
        return alphanumeric(v);
      case 6: // National id
        return validateInternationalId(v);
      default:
        return alphanumeric(v);
    }
  };

  const getDocConfig = (doc) => {
    const id = Number(doc.id);
    switch (id) {
      case 1:
        return { front: true, back: true, pdf: false }; // Passport
      case 2:
        return { front: true, back: true, pdf: false }; // Aadhaar
      case 3:
        return { front: true, back: false, pdf: false }; // PAN
      case 4:
      case 5:
        return { front: true, back: false, pdf: true }; // Bank / ITR
      default:
        return { front: true, back: false, pdf: false };
    }
  };

  // useEffect(() => {
  //   async function loadAirports() {
  //     const res = await authRequestNbGet("airports");
  //     if (res.status === 200) {
  //       setAirports(res.data || []);
  //     }
  //   }
  //   loadAirports();
  // }, []);

  useEffect(() => {
    let active = true;

    (async () => {
      if (!slug) {
        navigate("/dashboard", { replace: true });
        return;
      }

      try {
        setTourAccessReady(false);

        const [tourResponse, myToursResponse] = await Promise.all([
          authRequestNbGet(`tours/${slug}`),
          authRequestNbGet("get-my-tour"),
        ]);

        if (!active) return;

        if (tourResponse?.token) await refreshToken(tourResponse.token);
        if (myToursResponse?.token) await refreshToken(myToursResponse.token);

        if (Number(tourResponse?.status) !== 200 || !tourResponse?.data) {
          navigate("/dashboard", { replace: true });
          return;
        }

        const latestTour = tourResponse.data || {};
        setTour(latestTour);
        setAirports(latestTour?.departure_airports || []);
        setDocumentType(latestTour?.document_types || []);
        setMyTourRows(
          Number(myToursResponse?.status) === 200 &&
            Array.isArray(myToursResponse?.data)
            ? myToursResponse.data
            : [],
        );
      } catch (error) {
        console.error("Unable to load tour access:", error);
        if (active) {
          navigate("/dashboard", { replace: true });
        }
      } finally {
        if (active) setTourAccessReady(true);
      }
    })();

    return () => {
      active = false;
    };
  }, [slug, navigate]);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    (async () => {
      try {
        const res = await authRequestNbGet(`me/travelers?tour_id=${tourdata.id}`);
        if (res && res.status === 200) {
          const token = res.token;
          if (token) {
            await refreshToken(token);
          }
          setSavedPassengers(res.data || []);
        }
      } catch (err) {}
    })();
  }, []);

  const getAvailableSavedPassengers = (currentPassengerId) => {
    const chosenIds = Object.entries(passengerTraveler)
      .filter(([pid, val]) => val && Number(pid) !== currentPassengerId)
      .map(([pid, val]) => String(val));

    return dropDownPassenger.filter((sp) => !chosenIds.includes(String(sp.id)));
  };

  const addCoPassenger = () => {
    if (!tourAccess.canOpenDocuments) {
      swal(
        "Tour Booking Unavailable",
        tourAccess.reason || "You are not eligible to modify this booking.",
        "warning",
      );
      return;
    }

    if (!bookingStarted) {
      swal(
        isBookingUpcoming
          ? "Booking has not started yet. This tour is upcoming."
          : "Booking is not available for this tour.",
      );

      return;
    }

    if (!applicationOpen) {
      swal(
        "Application deadline has passed. You cannot add another passenger.",
      );

      return;
    }

    if (maxPassengers <= 0) {
      swal("You are not eligible to add a passenger for this tour.");

      return;
    }

    if (coPassengers.length >= maxPassengers) {
      swal(
        `Passenger limit reached. Maximum ${maxPassengers} passenger${
          maxPassengers > 1 ? "s" : ""
        } allowed for this tour.`,
      );

      return;
    }

    setCoPassengers((prev) => [
      ...prev,
      {
        id: Date.now(),

        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        relationship: "",
        gender: "",

        date_of_birth: "",
        place_of_birth: "",
        date_of_issue: "",
        date_of_expiry: "",
        place_of_issue: "",

        travel_with: "",
        // near_by_airport: "",
        departure_airport_id: "",
        nationality: "",
      },
    ]);
  };

  const removeCoPassenger = (id) => {
    const passenger = coPassengers.find((p) => Number(p.id) === Number(id));

    if (isPassengerPaid(passenger)) {
      swal(
        "Passenger Locked",
        "This passenger is already paid and cannot be removed.",
        "warning",
      );

      return;
    }

    if (coPassengers.length > 1) {
      setCoPassengers(coPassengers.filter((p) => p.id !== id));

      setDocNumbers((prev) => {
        const copy = { ...prev };
        delete copy[id];
        return copy;
      });
      setPreviews((prev) => {
        const copy = { ...prev };
        delete copy[id];
        return copy;
      });
      setPassengerTraveler((prev) => {
        const copy = { ...prev };
        delete copy[id];
        return copy;
      });
      setFieldErrors((prev) => {
        const copy = { ...prev };
        delete copy[id];
        return copy;
      });
      setDocErrors((prev) => {
        const copy = { ...prev };
        delete copy[id];
        return copy;
      });
      setPhotoErrors((prev) => {
        const copy = { ...prev };
        delete copy[id];
        return copy;
      });
    }
  };

  const handlePassengerFieldChange = (passengerId, field, value) => {
    switch (field) {
      case "firstName":
      case "lastName":
      case "place_of_birth":
      case "place_of_issue":
        if (!allLetter(value)) return;
        break;
      case "email":
        if (!/^[a-zA-Z0-9@._+-]*$/.test(value)) return;
        break;
      case "phone":
        if (!/^[0-9+]*$/.test(value)) return;
        break;
      case "gender":
      case "relationship":
        break;
      case "travel_with":
      case "date_of_birth":
      case "date_of_issue":
      case "date_of_expiry":
      case "nationality":
      case "departure_airport_id":
        break;
      default:
        if (!mandsCheck(value)) return;
    }

    setFieldErrors((prev) => ({
      ...prev,
      [passengerId]: {
        ...(prev[passengerId] || {}),
        [field]: "",
      },
    }));

    setCoPassengers((prev) =>
      prev.map((p) => {
        if (p.id !== passengerId) return p;
        // if (field === "nationality") {
        //   return { ...p, nationality: value, near_by_airport: "" };
        // }

        return { ...p, [field]: value };
      }),
    );
  };

  const handlePhotoChange = (e, passengerId) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 1024 * 1024 * 2) {
      setPhotoErrors((prev) => ({
        ...prev,
        [passengerId]: "Photo must be less than 2 MB",
      }));
      return;
    }

    if (!file.type.startsWith("image/")) {
      swal("Please upload a valid image file (jpg, png, etc.)");
      return;
    }

    const reader = new FileReader();
    reader.onload = (ev) => {
      const img = new Image();
      img.onload = () => {
        const width = img.width;
        const height = img.height;

        setPhotos((prev) => ({
          ...prev,
          [passengerId]: {
            file,
            preview: ev.target.result,
            isExisting: false,
          },
        }));

        setPhotoErrors((prev) => ({
          ...prev,
          [passengerId]: "",
        }));
      };

      img.src = ev.target.result;
    };

    reader.readAsDataURL(file);
  };

  const blankPassenger = (id) => ({
    id,
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    relationship: "",
    gender: "",
    date_of_birth: "",
    place_of_birth: "",
    date_of_issue: "",
    date_of_expiry: "",
    place_of_issue: "",
    travel_with: "",
    tour_status: "",
    transaction_hash: "",
    transaction_status: "",
    nationality: "",
    // near_by_airport: "",
    departure_airport_id: "",
  });

  const handleSelectSavedPassenger = async (passengerId, travelerId) => {
    const tid = travelerId ? String(travelerId) : "";

    setPassengerTraveler((prev) => ({
      ...prev,
      [passengerId]: tid ? tid : null,
    }));

    setDocNumbers((prev) => {
      const copy = { ...prev };
      delete copy[passengerId];
      return copy;
    });

    setPreviews((prev) => {
      const copy = { ...prev };
      delete copy[passengerId];
      return copy;
    });

    if (!tid) {
      setCoPassengers((prev) =>
        prev.map((p) =>
          p.id === passengerId ? blankPassenger(passengerId) : p,
        ),
      );

      setPhotos((prev) => {
        const copy = { ...prev };
        delete copy[passengerId];
        return copy;
      });

      setFieldErrors((prev) => {
        const copy = { ...prev };
        delete copy[passengerId];
        return copy;
      });
      setDocErrors((prev) => {
        const copy = { ...prev };
        delete copy[passengerId];
        return copy;
      });
      setPhotoErrors((prev) => {
        const copy = { ...prev };
        delete copy[passengerId];
        return copy;
      });

      return;
    }

    if (!travelerId) return;

    const selected =
  savedPassengers.find(
    (sp) =>
      String(sp.id) ===
      String(travelerId)
  ) ||
  dropDownPassenger.find(
    (sp) =>
      String(sp.id) ===
      String(travelerId)
  );

    // const selected = savedPassengers.find(
    //   (sp) => String(sp.id) === String(travelerId),
    // );

  //   const selected =
  // dropDownPassenger.find(
  //   (sp) =>
  //     String(sp.id) ===
  //     String(travelerId)
  // ) ||
  // savedPassengers.find(
  //   (sp) =>
  //     String(sp.id) ===
  //     String(travelerId)
  // );

    if (selected) {
      setCoPassengers((prev) =>
        prev.map((p) =>
          p.id === passengerId
            ? {
                ...p,
                firstName: selected.first_name || "",
                lastName: selected.last_name || "",
                email: selected.email || "",
                phone: selected.mobile || "",
                relationship: selected.relationship || "",
                gender: selected.gender || "",
                date_of_birth: selected.date_of_birth || "",
                place_of_birth: selected.place_of_birth || "",
                date_of_issue: selected.date_of_issue || "",
                date_of_expiry: selected.date_of_expiry || "",
                place_of_issue: selected.place_of_issue || "",
                travel_with: selected.travel_with || "",
                tour_status: selected.tour_status || "",
                transaction_hash: selected.transaction_hash || "",
                transaction_status: selected.transaction_status || "",
                nationality: selected.nationality || "",
                near_by_airport: selected.near_by_airport || "",
                departure_airport_id: selected.departure_airport_id ? String(selected.departure_airport_id) : "",
              }
            : p,
        ),
      );

      if (selected.image) {
        setPhotos((prev) => ({
          ...prev,
          [passengerId]: {
            file: null,
            preview: assetUrl + selected.image,
            isExisting: true,
          },
        }));
      }
    }

    try {
      const resp = await sendRequest(
        { traveler_id: travelerId },
        "get-traveler-documents",
      );

      if (resp.status === 404) return;
      if (resp.status !== 200 || !resp.data) {
        return;
      }

      const docsArray = resp.data;

for (const doc of docsArray) {
  const docTypeId = Number(doc.doc_type);
  const docNo = doc.doc_no || "";
  const frontPath = doc.doc_front || "";
  const backPath = doc.doc_back || "";

  const isFrontPdf = frontPath.toLowerCase().endsWith(".pdf");
  const isBackPdf = backPath.toLowerCase().endsWith(".pdf");

  setDocNumbers((prev) => ({
    ...prev,
    [passengerId]: {
      ...(prev?.[passengerId] || {}),
      [docTypeId]: docNo,
    },
  }));

  // FRONT
  if (frontPath) {
    setDocLoading(passengerId, docTypeId, "front", true);

    privateDocumentUrl(doc.id, "front")
      .then((frontUrl) => {
        setPreviews((prev) => ({
          ...prev,
          [passengerId]: {
            ...(prev[passengerId] || {}),
            [docTypeId]: {
              ...(prev[passengerId]?.[docTypeId] || {}),
              front: {
                file: null,
                preview: frontUrl,
                isPdf: isFrontPdf,
              },
            },
          },
        }));
      })
      .catch((err) => {
        console.error("Front document load failed:", err);
      })
      .finally(() => {
        setDocLoading(passengerId, docTypeId, "front", false);
      });
  }

  // BACK
  if (backPath) {
    setDocLoading(passengerId, docTypeId, "back", true);

    privateDocumentUrl(doc.id, "back")
      .then((backUrl) => {
        setPreviews((prev) => ({
          ...prev,
          [passengerId]: {
            ...(prev[passengerId] || {}),
            [docTypeId]: {
              ...(prev[passengerId]?.[docTypeId] || {}),
              back: {
                file: null,
                preview: backUrl,
                isPdf: isBackPdf,
              },
            },
          },
        }));
      })
      .catch((err) => {
        console.error("Back document load failed:", err);
      })
      .finally(() => {
        setDocLoading(passengerId, docTypeId, "back", false);
      });
  }
}
    } catch (e) {}
  };

  const handleDocNumberChange = (passengerId, docId, value) => {
    const trimmed = (value || "").trim();

    const PASSPORT_DOC_ID = 1;
    if (Number(docId) === PASSPORT_DOC_ID && trimmed) {
      const isDuplicate = Object.entries(docNumbers || {}).some(
        ([pid, docs]) =>
          Number(pid) !== passengerId &&
          (docs?.[PASSPORT_DOC_ID] || "").trim().toUpperCase() ===
            trimmed.toUpperCase(),
      );

      if (isDuplicate) {
        swal(
          "This passport number is already used for another passenger in this booking.",
        );
        return;
      }
    }

    setDocNumbers((prev) => ({
      ...(prev || {}),
      [passengerId]: {
        ...(prev?.[passengerId] || {}),
        [docId]: value,
      },
    }));

    setDocErrors((prev) => {
      const passengerErr = prev[passengerId] || {};
      const docErr = passengerErr[docId] || {};
      const updatedDocErr = { ...docErr, number: "" };

      return {
        ...prev,
        [passengerId]: {
          ...passengerErr,
          [docId]: updatedDocErr,
        },
      };
    });
  };

  const handleFileChange = (e, passengerId, docId, side) => {
    const file = e.target.files[0];
    if (!file) return;

    const setSideError = (msg) => {
      setDocErrors((prev) => {
        const passengerErr = prev[passengerId] || {};
        const docErr = passengerErr[docId] || {};
        const updatedDocErr = {
          ...docErr,
          [side]: msg,
        };

        return {
          ...prev,
          [passengerId]: {
            ...passengerErr,
            [docId]: updatedDocErr,
          },
        };
      });
    };
    if (file.size > 20 * 1024 * 1024) {
      setSideError("File size must be less than 20 MB");
      e.target.value = ""; // clear input
      return;
    }
    const allowedImageTypes = ["image/jpeg", "image/jpg", "image/png"];
    const isPdf = file.type === "application/pdf";

    const docConfig = getDocConfig({ id: docId });

    if (docConfig.pdf) {
      if (!isPdf) {
        setSideError("Only PDF files are allowed for this document");
        e.target.value = "";
        return;
      }
    } else {
      if (!allowedImageTypes.includes(file.type)) {
        setSideError("Only JPG, PNG or WEBP image files are allowed");
        e.target.value = "";
        return;
      }
    }

    if (isPdf) {
      const pdfUrl = URL.createObjectURL(file);
      setPreviewFn(passengerId, docId, side, file, pdfUrl, true);
    } else {
      const reader = new FileReader();
      reader.onloadend = () =>
        setPreviewFn(passengerId, docId, side, file, reader.result, false);
      reader.readAsDataURL(file);
    }

    setDocErrors((prev) => {
      const passengerErr = prev[passengerId] || {};
      const docErr = passengerErr[docId] || {};
      const updatedDocErr = { ...docErr, [side]: "" };

      return {
        ...prev,
        [passengerId]: {
          ...passengerErr,
          [docId]: updatedDocErr,
        },
      };
    });
  };

  const setPreviewFn = (passengerId, docId, side, file, preview, isPdf) => {
    setPreviews((prev) => ({
      ...prev,
      [passengerId]: {
        ...(prev[passengerId] || {}),
        [docId]: {
          ...(prev[passengerId]?.[docId] || {}),
          [side]: { file, preview, isPdf },
        },
      },
    }));
  };

  const scrollToError = (errInfo) => {
    if (!errInfo) return;
    let selector = "";

    if (errInfo.type === "field") {
      selector = `[data-error="field-${errInfo.passengerId}-${errInfo.field}"]`;
    } else if (errInfo.type === "photo") {
      selector = `[data-error="photo-${errInfo.passengerId}"]`;
    } else if (errInfo.type === "doc") {
      selector = `[data-error="doc-${errInfo.passengerId}-${errInfo.docId}"]`;
    }

    if (!selector) return;

    setTimeout(() => {
      const el = document.querySelector(selector);
      if (el && typeof el.scrollIntoView === "function") {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 0);
  };

  const buildPayload = () => {
    if (!tour || !tour.id) {
      return { ok: false, firstError: null };
    }

    const data = {};
    data.tour_id = tour.id;

    let hasError = false;
    let firstError = null;
    const newFieldErrors = {};
    const newDocErrors = {};
    const newPhotoErrors = {};

    const collectedDocNos = [];
    const normalizeDocNo = (s) => (s || "").trim().toUpperCase();

    const passengersPayload = coPassengers.map((pax, index) => {
      const label = index === 0 ? "Main passenger" : `Co-passenger ${index}`;
      const tempId = "p" + pax.id;
      const travelerId = passengerTraveler[pax.id] || null;

      const firstName = (pax.firstName || "").trim();
      const lastName = (pax.lastName || "").trim();
      const email = (pax.email || "").trim();
      const phone = (pax.phone || "").trim();
      const relationship = (pax.relationship || "").trim();
      const gender = (pax.gender || "").trim();
      const date_of_birth = (pax.date_of_birth || "").trim();
      const place_of_birth = (pax.place_of_birth || "").trim();
      const date_of_issue = (pax.date_of_issue || "").trim();
      const date_of_expiry = (pax.date_of_expiry || "").trim();
      const place_of_issue = (pax.place_of_issue || "").trim();
      const travel_with = (pax.travel_with || "").trim();
      // const near_by_airport = (pax.near_by_airport || "").trim();
      const departure_airport_id = pax.departure_airport_id
  ? Number(pax.departure_airport_id)
  : null;
      const nationality = (pax.nationality || "").trim();
      const age = calcAgeFromDob(date_of_birth);
      const isMinor = age !== null && age < 18;

      const fe = (newFieldErrors[pax.id] = newFieldErrors[pax.id] || {});

      if (!firstName) {
        fe.firstName = "First name is required";
        hasError = true;
        if (!firstError) {
          firstError = {
            type: "field",
            passengerId: pax.id,
            field: "firstName",
          };
        }
      } else if (!allLetter(firstName)) {
        fe.firstName = "First name should contain only letters/spaces";
        hasError = true;
        if (!firstError) {
          firstError = {
            type: "field",
            passengerId: pax.id,
            field: "firstName",
          };
        }
      }

      if (!lastName) {
        fe.lastName = "Last name is required";
        hasError = true;
        if (!firstError) {
          firstError = {
            type: "field",
            passengerId: pax.id,
            field: "lastName",
          };
        }
      } else if (!allLetter(lastName)) {
        fe.lastName = "Last name should contain only letters/spaces";
        hasError = true;
        if (!firstError) {
          firstError = {
            type: "field",
            passengerId: pax.id,
            field: "lastName",
          };
        }
      }

      if (!email) {
        fe.email = "Email is required";
        hasError = true;
        if (!firstError) {
          firstError = {
            type: "field",
            passengerId: pax.id,
            field: "email",
          };
        }
      } else if (!validateEmail(email)) {
        fe.email = "Please enter a valid email";
        hasError = true;
        if (!firstError) {
          firstError = {
            type: "field",
            passengerId: pax.id,
            field: "email",
          };
        }
      }

      if (!phone) {
        fe.phone = "Phone is required";
        hasError = true;
        if (!firstError) {
          firstError = {
            type: "field",
            passengerId: pax.id,
            field: "phone",
          };
        }
      } else if (!vIndiaphone(phone)) {
        fe.phone = "Please enter a valid mobile number (e.g. +919876543210)";
        hasError = true;
        if (!firstError) {
          firstError = {
            type: "field",
            passengerId: pax.id,
            field: "phone",
          };
        }
      }

      if (!gender) {
        fe.gender = "Gender is required";
        hasError = true;
        if (!firstError) {
          firstError = {
            type: "field",
            passengerId: pax.id,
            field: "gender",
          };
        }
      }

      if (!date_of_birth) {
        fe.date_of_birth = "Date of birth is required";
        hasError = true;
        if (!firstError) {
          firstError = {
            type: "field",
            passengerId: pax.id,
            field: "date_of_birth",
          };
        }
      }
      if (!place_of_birth) {
        fe.place_of_birth = "Place of birth is required";
        hasError = true;
        if (!firstError) {
          firstError = {
            type: "field",
            passengerId: pax.id,
            field: "place_of_birth",
          };
        }
      }

      if (!date_of_issue) {
        fe.date_of_issue = "Date of issue is required";
        hasError = true;
        if (!firstError) {
          firstError = {
            type: "field",
            passengerId: pax.id,
            field: "date_of_issue",
          };
        }
      }
      if (!date_of_expiry) {
        fe.date_of_expiry = "Date of expiry is required";
        hasError = true;
        if (!firstError) {
          firstError = {
            type: "field",
            passengerId: pax.id,
            field: "date_of_expiry",
          };
        }
      }
      if (!place_of_issue) {
        fe.place_of_issue = "Place of issue is required";
        hasError = true;
        if (!firstError) {
          firstError = {
            type: "field",
            passengerId: pax.id,
            field: "place_of_issue",
          };
        }
      }

      if (index > 0 && !relationship) {
        fe.relationship = "Relationship with main passenger is required";
        hasError = true;
        if (!firstError) {
          firstError = {
            type: "field",
            passengerId: pax.id,
            field: "relationship",
          };
        }
      }

      // if (index === 0 && !near_by_airport) {
      //   fe.near_by_airport = "Please select nearest international airport";
      //   hasError = true;
      //   if (!firstError) {
      //     firstError = {
      //       type: "field",
      //       passengerId: pax.id,
      //       field: "near_by_airport",
      //     };
      //   }
      // }

      if (!departure_airport_id) {
        fe.departure_airport_id = "Please select departure airport";
        hasError = true;

        if (!firstError) {
          firstError = {
            type: "field",
            passengerId: pax.id,
            field: "departure_airport_id",
          };
        }
      }

      const isValidDepartureAirport = airports.some(
          (airport) => Number(airport.id) === Number(departure_airport_id),
        );

        if (!departure_airport_id || !isValidDepartureAirport) {
          fe.departure_airport_id =
            "Please select a valid departure airport for this tour";

          hasError = true;

          if (!firstError) {
            firstError = {
              type: "field",
              passengerId: pax.id,
              field: "departure_airport_id",
            };
          }
        }

      if (index === 0 && !nationality) {
        fe.nationality = "Please select your nationality";
        hasError = true;
        if (!firstError) {
          firstError = {
            type: "field",
            passengerId: pax.id,
            field: "nationality",
          };
        }
      }

      const photo = photos[pax.id];
      const hasNewFile = photo && photo.file;
      const hasExisting =
        photo && (photo.isExisting || (!photo.file && photo.preview));

      if (!photo || (!hasNewFile && !hasExisting)) {
        newPhotoErrors[pax.id] = "Passport size photo is required";
        hasError = true;
        if (!firstError) {
          firstError = {
            type: "photo",
            passengerId: pax.id,
          };
        }
      } else if (hasNewFile) {
        data[`${tempId}_image`] = photo.file;
      }

      const docs = {};
      const de = (newDocErrors[pax.id] = newDocErrors[pax.id] || {});

      documentType.forEach((doc) => {
        const docId = doc.id;
        const docName = doc.name || doc.document || `Document ${docId}`;

        const config = getDocConfig(doc);

        if (isMinor && Number(docId) === 3) {
          return;
        }

        if (shouldSkipDoc(docId, docName, isMinor, nationality)) return;

        const docNoRaw = (docNumbers[pax.id]?.[docId] || "").trim();
        const docNoNorm = normalizeDocNo(docNoRaw);
        const paxDoc = previews[pax.id]?.[docId] || {};
        const front = paxDoc.front;
        const back = paxDoc.back;

        const hasFrontFile = front && front.file;
        const hasBackFile = back && back.file;

        const hasFrontExisting = !!front?.preview; // existing URL also
        const hasBackExisting = !!back?.preview;

        const docErr = (de[docId] = de[docId] || {});

        if (docName !== "Last 3 Years ITR") {
          if (!docNoRaw) {
            docErr.number = `Please enter ${docName} number`;
            hasError = true;
            if (!firstError) {
              firstError = {
                type: "doc",
                passengerId: pax.id,
                docId,
              };
            }
            return;
          }
        }

        if (docName !== "Last 3 Years ITR") {
          if (!validateDocNumberByType(docId, docNoRaw)) {
            docErr.number = `Please enter a valid ${docName} number`;
            hasError = true;
            if (!firstError) {
              firstError = {
                type: "doc",
                passengerId: pax.id,
                docId,
              };
            }
          }
          collectedDocNos.push({
            passengerId: pax.id,
            docId,
            docName,
            docNoNorm,
          });
        }

        if (config.front && !(hasFrontFile || hasFrontExisting)) {
          docErr.front = `${docName} front file is required`;
          hasError = true;
          if (!firstError)
            firstError = { type: "doc", passengerId: pax.id, docId };
        }

        if (config.back && !(hasBackFile || hasBackExisting)) {
          docErr.back = `${docName} back file is required`;
          hasError = true;
          if (!firstError)
            firstError = { type: "doc", passengerId: pax.id, docId };
        }

        docs[docId] = { doc_no: docNoRaw };

        if (hasFrontFile) {
          data[`${tempId}_doc_${docId}_front`] = front.file;
        }
        if (hasBackFile) {
          data[`${tempId}_doc_${docId}_back`] = back.file;
        }
      });

      return {
        temp_id: tempId,
        id: travelerId || null,
        type: index === 0 ? "main" : "co-passenger",
        first_name: firstName,
        last_name: lastName,
        email,
        mobile: phone,
        relationship,
        gender,
        date_of_birth,
        place_of_birth,
        date_of_issue,
        date_of_expiry,
        place_of_issue,
        travel_with,
        // near_by_airport,
        departure_airport_id,
        nationality,
        tour_status: pax.tour_status || "",
        transaction_hash: pax.transaction_hash || "",
        transaction_status: pax.transaction_status || "",
        documents: Object.entries(docs).map(([docType, doc]) => ({
          doc_type: Number(docType),
          doc_no: doc.doc_no || "",
        })),
      };
    });

    const seen = {}; // key: `${docId}__${docNoNorm}` -> firstPassengerId
    collectedDocNos.forEach(({ passengerId, docId, docName, docNoNorm }) => {
      const key = `${docId}__${docNoNorm}`;
      if (!seen[key]) {
        seen[key] = passengerId;
        return;
      }

      const otherPassengerId = seen[key];
      if (otherPassengerId === passengerId) return;

      newDocErrors[passengerId] = newDocErrors[passengerId] || {};
      newDocErrors[otherPassengerId] = newDocErrors[otherPassengerId] || {};
      newDocErrors[passengerId][docId] = newDocErrors[passengerId][docId] || {};
      newDocErrors[otherPassengerId][docId] =
        newDocErrors[otherPassengerId][docId] || {};

      const msg = `${docName} number must be unique for each passenger`;

      if (!newDocErrors[passengerId][docId].number)
        newDocErrors[passengerId][docId].number = msg;
      if (!newDocErrors[otherPassengerId][docId].number)
        newDocErrors[otherPassengerId][docId].number = msg;

      hasError = true;
      if (!firstError) {
        firstError = { type: "doc", passengerId, docId };
      }
    });

    if (hasError) {
      setFieldErrors(newFieldErrors);
      setDocErrors(newDocErrors);
      setPhotoErrors(newPhotoErrors);
      return { ok: false, firstError: firstError || null };
    }

    data.passengers = JSON.stringify(passengersPayload);
    setFieldErrors({});
    setDocErrors({});
    setPhotoErrors({});

    return { ok: true, data, passengersPayload };
  };

  const handleSubmit = () => {
    if (!tourAccess.canOpenDocuments) {
      swal(
        "Tour Booking Unavailable",
        tourAccess.reason || "You are not eligible to book this tour.",
        "warning",
      );
      return;
    }

    if (allPassengersPaid) {
      swal(
        "Already Paid",
        "All passengers in this booking are already paid. No further payment or redemption is required.",
        "info",
      );

      return;
    }

    if (!bookingStarted) {
      swal(
        isBookingUpcoming
          ? "Booking has not started yet. This tour is upcoming."
          : "Booking is not available for this tour.",
      );

      return;
    }

    if (alreadyApplied === 0 && (!applicationOpen || maxPassengers <= 0)) {
      swal("You are not eligible to book this tour.");

      return;
    }

    if (coPassengers.length > maxPassengers) {
      swal(
        `You can submit maximum ${maxPassengers} passenger${
          maxPassengers > 1 ? "s" : ""
        } for this tour.`,
      );

      return;
    }

    const result = buildPayload();

    if (!result.ok) {
      swal("Please fix the highlighted errors and try again.");

      scrollToError(result.firstError);

      return;
    }

    const { data, passengersPayload } = result;

    setConfirmPayload({
      data,
      passengersPayload,
    });

    setShowConfirm(true);
  };

  const handleCancelConfirm = () => {
    setShowConfirm(false);
  };

  const normalizeTravelerEmail = (
  value
) =>
  String(value || "")
    .trim()
    .toLowerCase();

const normalizeTravelerPhone = (
  value
) =>
  String(value || "")
    .replace(/\D/g, "");

const applyAssignedTravelerIds = ({
  data,
  passengersPayload,
  responseData,
}) => {
  const rows =
    Array.isArray(responseData)
      ? responseData
      : [];

  if (rows.length === 0) {
    throw new Error(
      "Passenger save succeeded but no traveler records were returned."
    );
  }

  const usedTravelerIds =
    new Set();

  const updatedPassengers =
    passengersPayload.map(
      (passenger) => {
        const existingId =
          Number(
            passenger?.id || 0
          );

        if (
          Number.isFinite(
            existingId
          ) &&
          existingId > 0
        ) {
          usedTravelerIds.add(
            String(existingId)
          );

          return {
            ...passenger,
            id: existingId,
          };
        }
        const passengerEmail =
          normalizeTravelerEmail(
            passenger?.email
          );

        const passengerPhone =
          normalizeTravelerPhone(
            passenger?.mobile
          );

        const matchedRow =
          rows.find((item) => {
            const traveler =
              item?.traveler;

            if (!traveler?.id) {
              return false;
            }

            if (
              usedTravelerIds.has(
                String(
                  traveler.id
                )
              )
            ) {
              return false;
            }

            const savedEmail =
              normalizeTravelerEmail(
                traveler.email
              );

            const savedPhone =
              normalizeTravelerPhone(
                traveler.mobile
              );

            const emailMatches =
              passengerEmail &&
              savedEmail &&
              passengerEmail ===
                savedEmail;

            const phoneMatches =
              passengerPhone &&
              savedPhone &&
              passengerPhone ===
                savedPhone;

            return (
              emailMatches ||
              phoneMatches
            );
          });

        const assignedId =
          Number(
            matchedRow
              ?.traveler
              ?.id || 0
          );

        if (
          !Number.isFinite(
            assignedId
          ) ||
          assignedId <= 0
        ) {
          throw new Error(
            `Unable to resolve saved traveler ID for ${passenger?.first_name || ""} ${passenger?.last_name || ""}`.trim()
          );
        }

        usedTravelerIds.add(
          String(assignedId)
        );

        return {
          ...passenger,
          id: assignedId,
        };
      }
    );
  const updatedData = {
    ...data,

    passengers:
      JSON.stringify(
        updatedPassengers
      ),
  };

  return {
    data:
      updatedData,

    passengersPayload:
      updatedPassengers,

    responseRows:
      rows,
  };
};

const handleConfirmSubmit =
  async () => {
    if (
      !tourAccess
        .canOpenDocuments
    ) {
      swal(
        "Tour Booking Unavailable",

        tourAccess.reason ||
          "You are not eligible to book this tour.",

        "warning"
      );

      return;
    }

    if (
      allPassengersPaid
    ) {
      swal(
        "Already Paid",

        "All passengers in this booking are already paid. No further payment or redemption is required.",

        "info"
      );

      return;
    }

    if (
      redeemLoading ||
      saveLoading
    ) {
      return;
    }

    try {
      setDetailSaved(
        false
      );

      const result =
        buildPayload();

      if (!result.ok) {
        swal(
          "Validation Error",

          "Please fix the highlighted errors and try again.",

          "error"
        );

        scrollToError(
          result.firstError
        );

        return;
      }

      setSaveLoading(
        true
      );

      const res =
        await sendFileRequest(
          result.data,
          "submit-travelers"
        );

      if (
        !res ||
        res.status !== 200
      ) {
        swal(
          res?.message ||
            "Unable to save documents. Please check files."
        );

        return;
      }

      if (res.token) {
        await refreshToken(
          res.token
        );
      }

      const hydratedPayload =
        applyAssignedTravelerIds({
          data:
            result.data,

          passengersPayload:
            result.passengersPayload,

          responseData:
            res.data,
        });

      // console.log(
      //   "FIRST submit-travelers response:",
      //   res.data
      // );

      // console.log(
      //   "Passengers after DB ID assignment:",
      //   hydratedPayload
      //     .passengersPayload
      // );

      const travelerIdMapping =
        {};

      hydratedPayload
        .passengersPayload
        .forEach(
          (passenger) => {
            const tempId =
              String(
                passenger
                  ?.temp_id ||
                  ""
              );

            const localPassengerId =
              tempId.replace(
                /^p/,
                ""
              );

            if (
              localPassengerId &&
              passenger?.id
            ) {
              travelerIdMapping[
                localPassengerId
              ] =
                String(
                  passenger.id
                );
            }
          }
        );

      setPassengerTraveler(
        (prev) => ({
          ...prev,
          ...travelerIdMapping,
        })
      );

      setConfirmPayload({
        data:
          hydratedPayload.data,

        passengersPayload:
          hydratedPayload
            .passengersPayload,
      });

      const savedTravelers =
        hydratedPayload
          .responseRows
          .map(
            (item) => ({
              ...(
                item?.traveler ||
                {}
              ),

              tour_user_id:
                item
                  ?.tour_user
                  ?.id,

              tourid:
                item
                  ?.tour_user
                  ?.tourid,

              tour_status:
                item
                  ?.tour_user
                  ?.status,

              transaction_hash:
                item
                  ?.tour_user
                  ?.transaction_hash,

              transaction_status:
                item
                  ?.tour_user
                  ?.transaction_status,
            })
          );

      setUserDetails({
        travelers:
          savedTravelers,

        responseRows:
          hydratedPayload
            .responseRows,
      });

      setDetailSaved(
        true
      );

      setShowConfirm(
        false
      );

      setShowRedeemPopup(
        true
      );
    } catch (err) {
      console.error(
        "Save passenger error:",
        err
      );

      const rawMessage =
        String(
          err?.message ||
            ""
        );

      const isNetworkError =
        /failed to fetch/i.test(
          rawMessage
        ) ||
        /network request failed/i.test(
          rawMessage
        ) ||
        /network error/i.test(
          rawMessage
        ) ||
        /timeout/i.test(
          rawMessage
        );

      await swal(
        "Unable to Continue",

        isNetworkError
          ? "We could not reach the booking server. Your redemption has NOT started and no points have been deducted. Please check your connection and try again."
          : (
              rawMessage ||
              "Something went wrong while saving your passenger details. Please try again."
            ),

        "error"
      );
    } finally {
      setSaveLoading(
        false
      );
    }
  };

  // const handleConfirmSubmit = async () => {
  //   if (!tourAccess.canOpenDocuments) {
  //     swal(
  //       "Tour Booking Unavailable",
  //       tourAccess.reason || "You are not eligible to book this tour.",
  //       "warning",
  //     );
  //     return;
  //   }

  //   if (allPassengersPaid) {
  //     swal(
  //       "Already Paid",
  //       "All passengers in this booking are already paid. No further payment or redemption is required.",
  //       "info",
  //     );

  //     return;
  //   }

  //   if (redeemLoading) {
  //     return;
  //   }

  //   try {
  //     setDetailSaved(false);

  //     const result = buildPayload();

  //     if (!result.ok) {
  //       swal(
  //         "Validation Error",
  //         "Please fix the highlighted errors and try again.",
  //         "error",
  //       );

  //       scrollToError(result.firstError);

  //       return;
  //     }

  //     const preparedPayload = {
  //       data: result.data,

  //       passengersPayload: result.passengersPayload,
  //     };

  //     setConfirmPayload(preparedPayload);
  //     setSaveLoading(true);
  //     const res = await sendFileRequest(result.data, "submit-travelers");
  //     if (!res || res.status !== 200) {
  //           setSaveLoading(false);

  //       swal(res?.message || "Unable to save documents. Please check files.");
  //       return;
  //     } else {
  //       setUserDetails(res.data);
  //     }

  //     if (res.token) await refreshToken(res.token);
  //     setSavedPassengers(res.data?.travelers || []);
  //     setDetailSaved(true);

  //     setShowConfirm(false);
  //     setShowRedeemPopup(true);

  //     } catch (err) {
  //       const rawMessage =
  //         String(err?.message || "");

  //       const isNetworkError =
  //         /failed to fetch/i.test(rawMessage) ||
  //         /network request failed/i.test(
  //           rawMessage
  //         ) ||
  //         /network error/i.test(rawMessage) ||
  //         /timeout/i.test(rawMessage);

  //       await swal(
  //         "Unable to Continue",
  //         isNetworkError
  //           ? "We could not reach the booking server. Your redemption has NOT started and no points have been deducted. Please check your connection and try again."
  //           : rawMessage ||
  //               "Something went wrong while saving your passenger details. Please try again.",
  //         "error"
  //       );
  //     }
  //   finally{
  //         setSaveLoading(false);
  //   }
  // };

  const finalizeBooking = async (
    payload,
    txHash = "",
    travelersOverride = null,
  ) => {
    try {
      // const paymentRows =
      //   typeof payload.passengers === "string"
      //     ? JSON.parse(payload.passengers)
      //     : payload.passengers || [];

      // const saved = Array.isArray(travelersOverride)
      //   ? travelersOverride
      //   : userDetails?.travelers || [];

      // for (const row of paymentRows) {
      //   const application = saved.find(
      //     (item) => Number(item.id) === Number(row.traveler_id),
      //   );

      //   if (!application?.tour_user_id) {
      //     throw new Error("Tour application was not found for a passenger.");
      //   }

      const apiRes = await sendRequest(
        // {
        //   tour_user_id: application.tour_user_id,

        //   transaction_hash: row.transaction_hash || txHash,
        // },
        payload,
        "tour-passenger-payment",
      );

      if (!apiRes || apiRes.status !== 200) {
        throw new Error(
          apiRes?.message ||
            "Redeem succeeded, but booking could not be finalized on the server.",
        );
      }

      if (apiRes.token) {
        await refreshToken(apiRes.token);
      }
      // }

      setPendingSubmit(null);

      setShowRedeemPopup(false);

      setShowConfirm(false);

      const displayHash =
        txHash || payload?.transaction_hash || payload?.txHash || "";
      setShowTransactionLoader(false);
      swal({
        title: "Journey Booked Successfully!",

        text:
          `Your journey has been booked.\n\n` +
          `Copy your redemption transaction hash for future enquiries:\n` +
          `${displayHash || "N/A"}`,

        icon: "success",

        buttons: {
          cancel: displayHash ? "Copy Tx Hash" : false,

          confirm: {
            text: "I Confirm",
            value: "confirm",
          },
        },
      }).then(async (value) => {
        if (value === null && displayHash) {
          try {
            await navigator.clipboard.writeText(displayHash);

            await swal(
              "Copied!",
              "Transaction hash copied to clipboard.",
              "success",
            );
          } catch (e) {
            await swal(
              "Copy failed",
              "Please copy the hash manually.",
              "error",
            );
          }
        }

        navigate("/dashboard", {
          replace: true,
        });
      });

      return true;
    } catch (err) {
      console.error("finalizeBooking error:", err);

      const message =
        err?.message || "Something went wrong while finalizing the booking.";

      setShowTransactionLoader(false);
      swal(
        "Redemption recorded on-chain",
        `${message}\n\nDo not redeem again. Use Retry Finalization.`,
        "error",
      );

      return false;
    }
  };

  useEffect(() => {
    if (!tour?.id || savedPassengers.length === 0 || prefillRef.current) return;

    const applied = savedPassengers.filter(
      (sp) => sp.tourid !== null && String(sp.tourid) === String(tour.id),
    );

    if (applied.length === 0) return;
    prefillRef.current = true;

    const main = applied.find((sp) => sp.type === "main") || applied[0];
    const coList = applied.filter((sp) => sp.id !== main.id);

    const newPassengers = [
      {
        id: Number(main.id),
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        relationship: main.relationship || "",
        gender: "",
        date_of_birth: "",
        place_of_birth: "",
        date_of_issue: "",
        date_of_expiry: "",
        place_of_issue: "",
        travel_with: main.travel_with || "",
        tour_status: main.tour_status || "",
        transaction_hash: main.transaction_hash || "",
        nationality: main.nationality || "",
        transaction_status: main.transaction_status || "",
        near_by_airport: main.near_by_airport || "",
      },
      ...coList.map((sp) => ({
        id: Number(sp.id),
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        relationship: sp.relationship || "",
        gender: "",
        date_of_birth: "",
        place_of_birth: "",
        date_of_issue: "",
        date_of_expiry: "",
        place_of_issue: "",
        travel_with: sp.travel_with || "",
        tour_status: sp.tour_status || "",
        transaction_hash: sp.transaction_hash || "",
        nationality: sp.nationality || "",
        transaction_status: sp.transaction_status || "",
        near_by_airport: sp.near_by_airport || "",
      })),
    ];

    setCoPassengers(newPassengers);

    applied.forEach((sp) => {
      const pid = Number(sp.id);
      handleSelectSavedPassenger(pid, sp.id);
    });
  }, [tour, savedPassengers]);

  const buildRedemptionPaymentPayload = (txHash) => {
    const newTravelerIds = userDetails?.newTravelerIds || [];

    const passengers = newTravelerIds.map((travelerId) => ({
      traveler_id: Number(travelerId),

      transaction_hash: txHash,
    }));

    return {
      tour_id: Number(currentTour?.id || confirmPayload?.data?.tour_id || 0),

      passengers: JSON.stringify(passengers),
    };
  };

  const redeemTourOnChain = async ({tourId, totalBillPoints, onTransactionHash}) => {
    let stage = "initializing";
    let submittedTxHash = "";

    try {
      if (!account) {
        throw new Error("Wallet not connected. Please connect your wallet.");
      }

      if (!tourId || Number(tourId) <= 0) {
        throw new Error("Invalid tour ID. Please refresh the page and try again.");
      }

      const pointsText = String(totalBillPoints ?? "").trim();

      if (!pointsText || !/^\d+$/.test(pointsText)) {
        throw new Error(`Invalid redemption points: ${pointsText || "0"}. The travel contract accepts whole points only.`);
      }

      const pointsValue = BigInt(pointsText);

      if (pointsValue <= 0n) {
        throw new Error("Redemption points must be greater than zero.");
      }

      stage = "network check";
      await ensureTBCNetwork();
      const userId = BigInt(String(user.id));
      const tourIdBigInt = BigInt(String(tourId));
      const passengerIds = confirmPayload.passengersPayload
          .map((passenger) => passenger.id);

      const bookingReference = createBookingReference({
    tourId: tourIdBigInt,
    userId: userId,
    passengerCount: confirmPayload.passengersPayload?.length,
    timestamp: Date.now(),
  });


      const walletProvider = getWalletProvider();
      const web3 = new Web3(walletProvider);
      const contract = new web3.eth.Contract(tourTbc.ABI, TRAVEL_REDEEM_CONTRACT);
      const redeemMethod = contract.methods.redeemForTravel(pointsValue.toString(), bookingReference);

      updateTransactionLoader({
        title: "Preparing Transaction",
        heading: "Checking Redemption",
        message: "Please wait while we prepare your travel point redemption."
      });

      stage = "estimate gas";
      const estimatedGas = await redeemMethod.estimateGas({from: account});
      const gasLimit = (BigInt(estimatedGas.toString()) * 120n) / 100n;

      updateTransactionLoader({
        title: "Sign Transaction",
        heading: "Waiting for Confirmation",
        message: "Please sign the travel point redemption transaction in your wallet."
      });

      stage = "send transaction";

      // const transaction = redeemMethod.send({
      //   from: account,
      //   gas: gasLimit.toString()
      // });

      const gasPrice = await web3.eth.getGasPrice();

      const transaction = redeemMethod.send({
        from: account,
        gas: gasLimit.toString(),
        gasPrice: gasPrice.toString(),
      });

      transaction.on("transactionHash", (txHash) => {
        submittedTxHash = txHash;
        stage = "wait for receipt";
        setSuccessRedeemHash(txHash);

        if (typeof onTransactionHash === "function") {
          onTransactionHash(txHash);
        }

        updateTransactionLoader({
          title: "Transaction Submitted",
          heading: "Waiting for Blockchain Confirmation",
          message: "Your redemption transaction has been submitted to Trust Bitcoin Mainnet.",
          txHash
        });
      });

      const receipt = await transaction;
      const transactionSucceeded = receipt?.status === true || receipt?.status === 1 || receipt?.status === 1n || String(receipt?.status) === "1";

      if (!transactionSucceeded) {
        const txError = new Error("Travel point redemption transaction failed on-chain.");
        txError.onChainFailed = true;
        txError.txHash = receipt?.transactionHash || submittedTxHash;
        throw txError;
      }

      const finalTxHash = receipt?.transactionHash || submittedTxHash;

      if (!finalTxHash) {
        throw new Error("Transaction succeeded but transaction hash was not returned.");
      }

      updateTransactionLoader({
        title: "Redemption Confirmed",
        heading: "Blockchain Confirmation Received",
        message: "Your travel points were redeemed successfully. Please do not close this page while we save your booking.",
        txHash: finalTxHash
      });

      return finalTxHash;
    } catch (error) {
      console.error(`Redemption failed at stage: ${stage}`, error);
      setShowTransactionLoader(false);

      const receiptStatus = error?.receipt?.status;
      const transactionFailed =
        error?.onChainFailed === true ||
        receiptStatus === false ||
        receiptStatus === 0 ||
        receiptStatus === 0n ||
        String(receiptStatus) === "0";

      if (transactionFailed) {
        const txError = new Error("Travel point redemption transaction failed on-chain.");
        txError.onChainFailed = true;
        txError.txHash = error?.receipt?.transactionHash || error?.txHash || submittedTxHash;
        throw txError;
      }

      const message = error?.message || "Unknown blockchain error";

      if (
        /failed to fetch/i.test(message) ||
        /network request failed/i.test(message) ||
        /network error/i.test(message)
      ) {
        const networkError = new Error(`Failed at ${stage}: ${message}`);
        networkError.txHash = submittedTxHash;
        throw networkError;
      }

      throw error;
    }
  };

const createBookingReference = ({
  tourId,
  userId,
  passengerCount,
  timestamp = Date.now(),
}) => {
  const VERSION = 1n;

  const MAX_UINT8 =
    (1n << 8n) - 1n;

  const MAX_UINT56 =
    (1n << 56n) - 1n;

  const MAX_UINT64 =
    (1n << 64n) - 1n;

  const checkUint64 = (
    value,
    field
  ) => {
    const n =
      BigInt(
        String(value)
      );

    if (
      n < 0n ||
      n > MAX_UINT64
    ) {
      throw new Error(
        `${field} exceeds uint64 limit`
      );
    }

    return n;
  };

  const tour =
    checkUint64(
      tourId,
      "tourId"
    );

  const user =
    checkUint64(
      userId,
      "userId"
    );

  const count =
    BigInt(
      String(
        passengerCount
      )
    );

  if (
    count < 1n ||
    count > MAX_UINT56
  ) {
    throw new Error(
      `passengerCount must be between 1 and ${MAX_UINT56.toString()}`
    );
  }

  const ts =
    checkUint64(
      timestamp,
      "timestamp"
    );

  if (
    VERSION >
    MAX_UINT8
  ) {
    throw new Error(
      "Version exceeds uint8 limit"
    );
  }

  let packed = 0n;

  /*
   * Layout:
   *
   * 8 bits  version
   * 64 bits tourId
   * 64 bits userId
   * 56 bits passengerCount
   * 64 bits timestamp
   *
   * TOTAL = 256 bits
   */

  // Version - 8 bits
  packed =
    (packed << 8n) |
    VERSION;

  // Tour ID - 64 bits
  packed =
    (packed << 64n) |
    tour;

  // User ID - 64 bits
  packed =
    (packed << 64n) |
    user;

  // Passenger Count - 56 bits
  packed =
    (packed << 56n) |
    count;

  // Timestamp - 64 bits
  packed =
    (packed << 64n) |
    ts;

  const hex =
    packed.toString(16);

  if (
    hex.length > 64
  ) {
    throw new Error(
      "Booking reference exceeds bytes32"
    );
  }

  return (
    "0x" +
    hex.padStart(
      64,
      "0"
    )
  );
};
  const handleRedeemNow = async () => {
    // console.log('confirmPayload', confirmPayload);
    if (allPassengersPaid) {
      swal(
        "Already Paid",
        "All passengers in this booking are already paid. No further payment or redemption is required.",
        "info"
      );
      return;
    }

    if (redeemLoading) return;

    if (!confirmPayload?.data || !Array.isArray(confirmPayload?.passengersPayload)) {
      swal(
        "Booking data is missing",
        "Please review the passenger details again.",
        "error"
      );
      return;
    }

    const saveTravelersAndFinalize = async ({txHash, preparedData, passengersPayload}) => {
      updateTransactionLoader({
        title: "Finalizing Booking",
        heading: "Saving Passenger Details",
        message: "Your points have been redeemed successfully. Please do not close or leave this page while we save your booking.",
        txHash
      });

      setPendingSubmit({
        stage: "submit-travelers",
        txHash,
        preparedData,
        passengersPayload
      });

      const res = await sendFileRequest(preparedData, "submit-travelers");

      if (!res || res.status !== 200) {
        throw new Error(res?.message || "Redemption succeeded, but passenger details could not be saved.");
      }

      const applications = Array.isArray(res.data) ? res.data : [];
      const filteredApplications = applications.filter((item) => {
        const hash = (item?.traveler?.transaction_hash || "").trim();
        const status = Number(item?.traveler?.transaction_status);
        return !(hash && (status === 0 || status === 1));
      });

      const travelers = filteredApplications.map((item) => ({
        ...(item.traveler || {}),
        tour_user_id: item.tour_user?.id,
        tourid: item.tour_user?.tourid,
        tour_status: item.tour_user?.status,
        transaction_hash: item.tour_user?.transaction_hash,
        transaction_status: item.tour_user?.transaction_status
      }));

      const mapping = Object.fromEntries(
        passengersPayload.map((passenger, index) => [
          passenger.temp_id,
          travelers[index]?.id
        ])
      );

      const newPassengerTempIds = passengersPayload.slice(alreadyApplied).map((passenger) => passenger.temp_id);
      const newTravelerIds = newPassengerTempIds.map((tempId) => Number(mapping[tempId])).filter((id) => Number.isFinite(id) && id > 0);

      setUserDetails({travelers, mapping, newPassengerTempIds, newTravelerIds});
      setSavedPassengers(travelers);

      if (res.token) await refreshToken(res.token);

      const payloadPassenger = filteredApplications.map((item) => ({
        traveler_id: Number(item.traveler.id),
        transaction_hash: txHash
      }));

      const paymentPayload = {
        tour_id: Number(currentTour?.id || preparedData?.tour_id || 0),
        passengers: payloadPassenger
      };

      setPendingSubmit({stage: "finalize-payment", txHash, payload: paymentPayload, travelers});

      updateTransactionLoader({
        title: "Finalizing Booking",
        heading: "Confirming Your Journey",
        message: "Your redemption is confirmed. We are completing your booking now. Please do not close this page.",
        txHash
      });

      return await finalizeBooking(paymentPayload, txHash, travelers);
    };

    if (newPassengerCount <= 0) {
      setRedeemLoading(true);

      try {
        updateTransactionLoader({
          title: "Saving Changes",
          heading: "Updating Passenger Details",
          message: "Please do not close this page while your changes are being saved."
        });

        setShowTransactionLoader(false);
        setShowRedeemPopup(false);
        setShowConfirm(false);

        await swal(
          "Details Updated",
          "Passenger details were updated successfully.",
          "success"
        );

        navigate("/dashboard", {replace: true});
      } catch (err) {
        console.error("Passenger update error:", err);
        setShowTransactionLoader(false);

        swal(
          "Unable to Save",
          err?.message || "Something went wrong while saving the passenger details.",
          "error"
        );
      } finally {
        setRedeemLoading(false);
      }

      return;
    }

    if (pendingSubmit?.txHash) {
      setRedeemLoading(true);

      try {
        if (pendingSubmit.stage === "submit-travelers") {
          await saveTravelersAndFinalize({
            txHash: pendingSubmit.txHash,
            preparedData: pendingSubmit.preparedData,
            passengersPayload: pendingSubmit.passengersPayload
          });
          return;
        }

        if (pendingSubmit.stage === "finalize-payment" && pendingSubmit.payload) {
          updateTransactionLoader({
            title: "Finalizing Booking",
            heading: "Retrying Booking Confirmation",
            message: "Your points are already redeemed. We are only completing the server booking. Do not redeem again.",
            txHash: pendingSubmit.txHash
          });

          await finalizeBooking(pendingSubmit.payload, pendingSubmit.txHash, pendingSubmit.travelers || null);
          return;
        }

        throw new Error("Unable to determine the pending booking stage.");
      } catch (err) {
        console.error("Retry finalization error:", err);
        setShowTransactionLoader(false);

        swal(
          "Booking Finalization Failed",
          `${err?.message || "Unable to complete the booking."}\n\nYour points are already redeemed. Do NOT redeem again. Please use Retry Finalization.`,
          "error"
        );
      } finally {
        setRedeemLoading(false);
      }

      return;
    }

    if (!account) {
      onConnect();
      return;
    }

    if (requiredPointUnitsPerPassenger <= 0) {
      swal(
        "Invalid Tour",
        "Tour redemption requirement is not configured.",
        "error"
      );
      return;
    }

    if (!hasEnoughRedeemBalance) {
      swal(
        "Insufficient Balance",
        `Required: ${formatPoints(totalPointsToRedeem)} point-equivalent.\nAvailable: ${formatPoints(availableEquivalentPoints)} point-equivalent.`,
        "error"
      );
      return;
    }

    const tourId = Number(currentTour?.id || confirmPayload?.data?.tour_id || 0);

    if (!Number.isFinite(tourId) || tourId <= 0) {
      swal(
        "Invalid Tour",
        "Tour ID was not found. Please refresh and try again.",
        "error"
      );
      return;
    }

    setRedeemLoading(true);

    let submittedTxHash = "";
    let confirmedTxHash = "";

    try {
      const txHash = await redeemTourOnChain({
        tourId,
        totalBillPoints: totalPointsToRedeem,
        onTransactionHash: (hash) => {
          submittedTxHash = hash;
        }
      });

      if (!txHash) {
        throw new Error("Redeem transaction did not return a transaction hash.");
      }

      confirmedTxHash = txHash;
      setSuccessRedeemHash(txHash);

      setPendingSubmit({
        stage: "submit-travelers",
        txHash,
        preparedData: confirmPayload.data,
        passengersPayload: confirmPayload.passengersPayload
      });

      await saveTravelersAndFinalize({
        txHash,
        preparedData: confirmPayload.data,
        passengersPayload: confirmPayload.passengersPayload
      });
    } catch (err) {
      setShowTransactionLoader(false);

      if (err?.onChainFailed) {
        const message = getBlockchainErrorMessage(err);
        swal("Redemption Failed", message, "error");
        return;
      }

      if (confirmedTxHash) {
        swal(
          "Redemption Confirmed - Booking Save Failed",
          `${err?.message || "The server could not complete your booking."}\n\nYour points have already been redeemed on Trust Bitcoin Mainnet.\n\nDo NOT redeem again. Click Retry Finalization to continue saving your booking.`,
          "error"
        );
        return;
      }

      if (submittedTxHash) {
        swal(
          "Transaction Submitted - Confirmation Pending",
          `The transaction was submitted to Trust Bitcoin Mainnet, but its confirmation could not be verified.\n\nTransaction Hash:\n${submittedTxHash}\n\nDo NOT redeem again until the transaction status has been checked.`,
          "warning"
        );
        return;
      }

      const message = getBlockchainErrorMessage(err);
      swal("Redemption Failed", message, "error");
    } finally {
      setRedeemLoading(false);
    }
  };


  if (!tourAccessReady || !currentTour?.id) {
    return (
      <>
        <div className="bgdashboard"></div>
        <Sidebar />
        <div className="dashboardMain sidebarPadding mainPanel">
          <div className="mainPanelIN">
            <div className="noTours w-100">
              <div className="noToursIcon">
                <i className="fa-solid fa-spinner fa-spin"></i>
              </div>
              <h4>Checking Tour Eligibility</h4>
              <p>Please wait while we verify the latest booking rules.</p>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (!tourAccess.canOpenDocuments) {
    return (
      <>
        <div className="bgdashboard"></div>
        <Sidebar />
        <div className="dashboardMain sidebarPadding mainPanel">
          <div className="mainPanelIN">
            <div className="noTours w-100">
              <div className="noToursIcon">
                <i className="fa-solid fa-lock"></i>
              </div>
              <h4>{tourAccess.statusLabel || "Tour Booking Unavailable"}</h4>
              <p>{tourAccess.reason || "This tour form is not available."}</p>
            </div>
          </div>
        </div>
      </>
    );
  }

    const getDepartureAirportLabel = (airportId) => {
  if (!airportId) return "N/A";

  const airport = airports.find(
    (item) => Number(item.id) === Number(airportId),
  );

  if (!airport) return `Airport ID: ${airportId}`;

  const code = airport.iata_code || airport.code || "";

  return `${airport.name}${code ? ` (${code})` : ""}${
    airport.city ? ` - ${airport.city}` : ""
  }`;
};

  return (
    <>
      {showConfirm && confirmPayload && (
        <>
          <div
            className="modalMain fixed inset-0 bg-black/50 flex items-center justify-center z-50"
            style={{ zIndex: 9999 }}
          >
            <div className="modalFlex h100">
              <div className="modalMainOver">
                <h5 className="text-xl font-bold mb-0">
                  Confirm Passenger Details
                </h5>
                <p className="f14 mb-2 text-sm text-gray-600">
                  Please check all details carefully before final submission:
                </p>

                <div className="">
                  {confirmPayload.passengersPayload.map((pax, idx) => (
                    <div
                      key={pax.temp_id}
                      className="border rounded p-2 px-3 mb-3"
                      style={{ borderColor: "#0000002d" }}
                    >
                      <h5 className="font-semibold mb-1">
                        Passenger #{idx + 1}{" "}
                        {pax.is_main ? "(Main Traveler)" : ""}
                      </h5>
                      <div className="row f14 text-sm ">
                        <div className="col-md-6 mb-2">
                          <strong>Name:</strong> {pax.first_name}{" "}
                          {pax.last_name}
                        </div>
                        <div className="col-md-6 mb-2">
                          <strong>Email:</strong> {pax.email}
                        </div>
                        <hr
                          style={{
                            height: "1px",
                            color: "#000",
                            width: "100%",
                          }}
                        />
                        <div className="col-md-6 mb-2">
                          <strong>Phone:</strong> {pax.mobile}
                        </div>
                        {pax.relationship && (
                          <div className="col-md-6 mb-2">
                            <strong>Relationship:</strong> {pax.relationship}
                          </div>
                        )}
                        <hr
                          style={{
                            height: "1px",
                            color: "#000",
                            width: "100%",
                          }}
                        />
                        <div className="col-md-6 mb-2">
                          <strong>Gender:</strong> {pax.gender}
                        </div>
                        <div className="col-md-6 mb-2">
                          <strong>DOB:</strong> {pax.date_of_birth}
                        </div>
                        <hr
                          style={{
                            height: "1px",
                            color: "#000",
                            width: "100%",
                          }}
                        />
                        <div className="col-md-6 mb-2">
                          <strong>Place of Birth:</strong> {pax.place_of_birth}
                        </div>
                        <hr
                          style={{
                            height: "1px",
                            color: "#000",
                            width: "100%",
                          }}
                        />
                      </div>

                      <div className=" f14 mt-1 text-sm">
                        <h6 className="mb-1">Documents:</h6>
                        <hr
                          style={{
                            height: "1px",
                            color: "#000",
                            width: "100%",
                          }}
                        />
                        {Object.keys(pax.documents || {}).length === 0 && (
                          <span> No documents filled.</span>
                        )}
                        <div className="row">
                          {(pax.documents || []).map((docInfo) => {
                            const docId = Number(docInfo.doc_type);

                            const docMeta = documentType.find(
                              (d) => Number(d.id) === docId,
                            );

                            const docName =
                              docMeta?.name ||
                              docMeta?.document ||
                              `Document ${docId}`;

                            return (
                              <React.Fragment key={docId}>
                                {docInfo.doc_no && (
                                  <>
                                    <div className="col-md-12 mb-2">
                                      <strong>
                                        <span className="font-medium">
                                          {docName}
                                        </span>{" "}
                                        Number:
                                      </strong>{" "}
                                      {docInfo.doc_no}
                                    </div>

                                    <hr
                                      style={{
                                        height: "1px",
                                        color: "#000",
                                        width: "100%",
                                      }}
                                    />
                                  </>
                                )}

                                {docId === 1 && (
                                  <>
                                    <div className="col-md-6 mb-2">
                                      <strong>Date of Issue:</strong>{" "}
                                      {pax.date_of_issue}
                                    </div>

                                    <div className="col-md-6 mb-2">
                                      <strong>Date of Expiry:</strong>{" "}
                                      {pax.date_of_expiry}
                                    </div>

                                    <hr
                                      style={{
                                        height: "1px",
                                        color: "#000",
                                        width: "100%",
                                      }}
                                    />

                                    <div className="col-md-6 mb-2">
                                      <strong>Place of Issue:</strong>{" "}
                                      {pax.place_of_issue}
                                    </div>

                                    <div className="col-md-6 mb-2">
                                      <strong>Nationality:</strong>{" "}
                                      {pax.nationality}
                                    </div>

                                    <hr
                                      style={{
                                        height: "1px",
                                        color: "#000",
                                        width: "100%",
                                      }}
                                    />
                                  </>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </div>
                      </div>
                      {idx === 0 && (
                        <div className="row f14 text-sm ">
                          {pax.travel_with && (
                            <div className="col-md-12 mb-2">
                              <strong>Travel With:</strong> {pax.travel_with}
                              <hr
                                style={{
                                  height: "1px",
                                  color: "#000",
                                  width: "100%",
                                }}
                              />
                            </div>
                          )}
                         <div className="col-md-12 mb-2">
                            <strong>Near By Airport:</strong>{" "}
                            {getDepartureAirportLabel(pax.departure_airport_id)}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                <div className="mt-0 d-flex justify-content-between gap-2 flex-wrap">
                  <button
                    type="button"
                    onClick={handleCancelConfirm}
                    className="text-center mt-1 mybtn d-flex gap-2 align-items-center order-2 order-md-1 secondaryBtn"
                  >
                    <span className="bgIN">Cancel / Edit</span>
                  </button>

                  <button
                    type="button"
                    onClick={handleConfirmSubmit}
                    className="text-center mt-1 mybtn btn-primary d-flex gap-2 align-items-center order-1 order-md-2"
                  >
                    <span className="bgIN">
                      {/* {!detailSaved ? "Save & Continue" : "Review Redemption"} */}
                      {saveLoading ? (
                        <>
                          <i className="fa-solid fa-spinner fa-spin me-2"></i>
                          Saving...
                        </>
                      ) : (
                        !detailSaved ? "Save & Continue" : "Review Redemption"
                      )}
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div className="modalShadow"></div>
          </div>
        </>
      )}
      {showNetworkPopup && (
        <>
          <div
            className="modalMain fixed inset-0 bg-black/50 flex items-center justify-center z-50"
            style={{ zIndex: 10000 }}
          >
            <div className="modalFlex">
              <div className="modalMainOver">
                <h5 className="text-xl font-bold mb-2">Select Network</h5>

                <p className="text-sm text-gray-600 mb-2">
                  Choose network to pay {payAmount} dollar(s).
                </p>

                <div style={{ overflowY: "auto" }}>
                  {networks.map((net) => (
                    <button
                      key={net.KEY}
                      type="button"
                      disabled={payLoading}
                      className="form-control mb-2 buttonHover"
                      style={{
                        textAlign: "left",
                        padding: "10px 12px",
                        cursor: "pointer",
                      }}
                    >
                      <div style={{ fontWeight: 600 }}>{net.NAME}</div>
                      <div style={{ fontSize: 12, opacity: 0.8 }}>
                        ChainId: {net.ID} • Symbol: {net.SYMBOL}
                      </div>
                    </button>
                  ))}
                </div>
                {selectedNetwork && (
                  <div
                    style={{ fontSize: 12, opacity: 0.8, alignSelf: "center" }}
                  >
                    Selected: <b>{selectedNetwork.NAME}</b>
                  </div>
                )}
                <div className="mt-2 d-flex justify-content-between gap-2">
                  <button
                    type="button"
                    disabled={payLoading}
                    onClick={() => setShowNetworkPopup(false)}
                    className="text-center mt-1 mybtn d-flex gap-2 align-items-center secondaryBtn"
                  >
                    <span className="bgIN">Cancel</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="modalShadow"></div>
          </div>
        </>
      )}

      {showRedeemPopup && (
        <>
          <div
            className="modalMain fixed inset-0 bg-black/50 flex items-center justify-center z-50"
            style={{
              zIndex: 10000,
            }}
          >
            <div className="modalFlex">
              <div className="modalMainOver">
                <h5 className="text-xl font-bold mb-2">
                  Confirm Tour Redemption
                </h5>

                <p className="f14 mb-3 text-sm text-gray-600">
                  Your passenger details are ready. Confirm the redemption for
                  NEW passengers only.
                </p>

                <div
                  className="border rounded p-2 px-3 mb-3 padding"
                  style={{
                    fontSize: 14,
                  }}
                >
                  <div className="d-flex justify-content-between mb-2 modalValue">
                    <span className="text-muted">New Passengers</span>

                    <strong className="modalValueData">
                      <i className="fa-solid fa-user-group valueIcon"></i>
                      {newPassengerCount}
                    </strong>
                  </div>

                  {requiredPoints > 0 && (
                    <div className="d-flex justify-content-between mb-2 modalValue">
                      <span className="text-muted">Points / Passenger</span>

                      <strong className="modalValueData">
                        <i className="fa-solid fa-gem valueIcon"></i>
                        {formatPoints(requiredPoints)}
                      </strong>
                    </div>
                  )}

                  <hr className="my-2" />

                  {totalRequiredPoints > 0 && (
                    <div className="d-flex justify-content-between mb-2 modalValue">
                      <span className="text-muted">Total Points</span>

                      <strong className="modalValueData">
                        <i className="fa-solid fa-gem valueIcon"></i>
                        {formatPoints(totalRequiredPoints)}
                      </strong>
                    </div>
                  )}

                  <div className="d-flex justify-content-between mb-2 modalValue">
                    <span className="text-muted">Total Point-Equivalent</span>

                    <strong className="modalValueData">
                      <i className="fa-solid fa-calculator valueIcon"></i>
                      {formatPoints(totalPointsToRedeem)}
                    </strong>
                  </div>

                  <div className="d-flex justify-content-between mb-2 modalValue">
                    <span className="text-muted">
                      Available Point-Equivalent
                    </span>

                    <strong
                      className={`modalValueData ${
                        hasEnoughRedeemBalance ? "text-success" : "text-danger"
                      }`}
                    >
                      <i className="fa-solid fa-wallet valueIcon"></i>

                      {formatPoints(availableEquivalentPoints)}
                    </strong>
                  </div>

                  {successRedeemHash && (
                    <div className="mt-2">
                      <small className="text-muted">Redeem Tx Hash</small>

                      <div
                        style={{
                          wordBreak: "break-all",

                          fontWeight: 600,
                        }}
                      >
                        {successRedeemHash}
                      </div>
                    </div>
                  )}
                </div>

                <div className="mt-3 d-flex justify-content-between gap-2 flex-wrap">
                  <button
                    type="button"
                    disabled={redeemLoading}
                    onClick={() => setShowRedeemPopup(false)}
                    className="text-center mt-1 mybtn d-flex gap-2 align-items-center secondaryBtn"
                  >
                    <span className="bgIN">Cancel</span>
                  </button>

                  <button
                    type="button"
                    disabled={
                      redeemLoading ||
                      (!hasEnoughRedeemBalance && !pendingSubmit?.txHash)
                    }
                    onClick={handleRedeemNow}
                    className="text-center mt-1 mybtn btn-primary d-flex gap-2 align-items-center"
                  >
                    <span className="bgIN">
                      {redeemLoading
                        ? "Processing..."
                        : pendingSubmit?.txHash
                          ? "Retry Finalization"
                          : "Redeem Now"}
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div className="modalShadow"></div>
          </div>
        </>
      )}

      <Modal
        className="modalWallet"
        isOpen={showTransactionLoader}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        onRequestClose={() => {}}
        contentLabel="Transaction Processing"
        style={{
          overlay: {
            zIndex: 20000,
            backgroundColor: "rgba(0, 0, 0, 0.72)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
          content: {
            position: "relative",
            inset: "auto",
            border: "none",
            background: "transparent",
            padding: "0",
            overflow: "visible",
          },
        }}
      >
        <div className="popupcenter text-center transactionLoaderPopup">
          <div className="edittext mb-2 modalHeader">
            <h5 className="colorDown upper">{transactionLoader.title}</h5>

            <span className="loaderM"></span>

            <h6 className="mb-1 Bold">{transactionLoader.heading}</h6>

            <div
              className="chain-dropdown-button swapBox justify-content-center f14"
              style={{
                padding: "5px",
                marginTop: "12px",
                color: "#a7a7a7",
              }}
            >
              {transactionLoader.message}
            </div>

            {/* {transactionLoader.txHash && (
              <div className="transactionHashBox mt-3">
                <small>Transaction Hash</small>

                <div className="transactionHashText">
                  {transactionLoader.txHash}
                </div>

                <a
                  href={`${TBC_NETWORK.EXPLORER}/tx/${transactionLoader.txHash}`}
                  target="_blank"
                  rel="noreferrer"
                  className="transactionExplorerLink"
                >
                  View on Explorer
                  <i className="fa-solid fa-arrow-up-right-from-square ms-1"></i>
                </a>
              </div>
            )} */}

            <div className="transactionWarning mt-3">
              <i className="fa-solid fa-circle-info me-1"></i>
              Please do not close, refresh, or leave this page.
            </div>
          </div>
        </div>
      </Modal>
      {showPaymentPopup && (
        <>
          <div
            className="modalMain fixed inset-0 bg-black/50 flex items-center justify-center z-50"
            style={{ zIndex: 10000 }}
          >
            <div className="modalFlex">
              <div className="modalMainOver">
                <h5 className="text-xl font-bold mb-2">Payment Details</h5>

                {(() => {
                  const perPassengerAmt = Number(parseFloat(amt).toFixed(2));
                  const passengerCount =
                    coPassengers.length - tourdata.alreadyApplied;
                  const totalPayable =
                    passengerCount > 0 ? perPassengerAmt * passengerCount : 0;

                  return (
                    <>
                      <div
                        className="p-3 rounded"
                        style={{
                          fontSize: 14,
                        }}
                      >
                        <div className="d-flex justify-content-between mb-2">
                          <span className="text-muted">Per Passenger</span>
                          <strong>${perPassengerAmt.toFixed(2)}</strong>
                        </div>

                        <div className="d-flex justify-content-between mb-2">
                          <span className="text-muted">All Passengers</span>
                          <strong>{coPassengers.length}</strong>
                        </div>

                        <div className="d-flex justify-content-between mb-2">
                          <span className="text-muted">Unpaid Passengers</span>
                          <strong className="text-danger">
                            {passengerCount}
                          </strong>
                        </div>

                        <div className="d-flex justify-content-between mb-3">
                          <span className="text-muted">Payable Amount</span>
                          <strong className="text-primary">
                            ${(passengerCount * perPassengerAmt).toFixed(2)}
                          </strong>
                        </div>

                        <hr className="my-2" />

                        <div className="d-flex justify-content-between align-items-center mt-2">
                          <span style={{ fontSize: 15, fontWeight: 500 }}>
                            Total
                          </span>
                          <span style={{ fontSize: 18, fontWeight: 700 }}>
                            ${totalPayable.toFixed(2)}
                          </span>
                        </div>
                      </div>
                      <div className="mt-2 d-flex justify-content-between gap-2 flex-wrap">
                        <button
                          type="button"
                          disabled={payLoading}
                          onClick={() => setShowPaymentPopup(false)}
                          className="text-center mt-1 mybtn d-flex gap-2 align-items-center w-100 w-md-auto secondaryBtn"
                        >
                          <span className="bgIN">Cancel</span>
                        </button>

                        {!account ? (
                          <button
                            type="button"
                            onClick={onConnect}
                            disabled={!!account}
                            className="text-center mt-1 mybtn btn-primary d-flex gap-2 align-items-center  order-1 order-md-2 w-100 w-md-auto"
                          >
                            <span className="bgIN">
                              {account ? account : "Connect Wallet"}
                            </span>
                          </button>
                        ) : (
                          <button
                            type="button"
                            onClick={() => {
                              if (totalPayable <= 0) {
                                setShowPaymentPopup(false);
                                setShowConfirm(false);
                                swal("No payment required.");
                                return;
                              }
                              setPayAmount(totalPayable);
                              setShowPaymentPopup(false);
                              setShowNetworkPopup(true);
                            }}
                            className="text-center mt-1 mybtn btn-primary d-flex gap-2 align-items-center w-100 w-md-auto"
                          >
                            <span className="bgIN">
                              Pay ($
                              {parseFloat(amt).toFixed(2) *
                                (coPassengers.length - tourdata.alreadyApplied)}
                              )
                            </span>
                          </button>
                        )}
                      </div>
                    </>
                  );
                })()}
              </div>
            </div>
            <div className="modalShadow"></div>
          </div>
        </>
      )}
      <div className="bgdashboard"></div>
      <Sidebar />
      <div className="dashboardMain sidebarPadding mainPanel">
        <div className="mainPanelIN">
          <section className="documentsBanner">
            <div className="documentsBannerIcon">
              <div className="documentIcon">
                <i className="fa-regular fa-file-lines"></i>
              </div>
            </div>

            <div className="documentsBannerContent">
              <h3>
                Documents For Verification{" "}
                {tour?.title ? `- ${toTitleCase(tour.title)}` : ""}
              </h3>

              <p>
                lease provide valid information and upload clear documents as
                per your passport details.
              </p>
            </div>

            <div className="documentsSkyline">
              <span className="skylineBuilding building1"></span>
              <span className="skylineBuilding building2"></span>
              <span className="skylineBuilding building3"></span>
              <span className="skylineBuilding building4"></span>

              <span className="skylineTower tower1"></span>
              <span className="skylineTower tower2"></span>
              <span className="skylineTower tower3"></span>

              <div className="travelBridge"></div>

              <i className="fa-solid fa-plane skylinePlane"></i>
            </div>
          </section>

          {coPassengers.map((pax, index) => {
            const current = coPassengers.find((p) => p.id === pax.id) || {};
            const isIndian =
              (current.nationality || "").trim().toLowerCase() === "india";

            const passengerPaid = isPassengerPaid(current);

            return (
              <fieldset
                disabled={passengerPaid}
                style={{
                  border: 0,
                  padding: 0,
                  margin: 0,
                  minWidth: 0,
                  width: "100%",
                  opacity: passengerPaid ? 0.8 : 1,
                }}
              >
                <React.Fragment key={pax.id}>
                  <div className="p-3 mb-4 rounded position-relative founderCard">
                    {index > 0 && !isPassengerPaid(current) && (
                      <button
                        type="button"
                        className="closePassengerBtn modalClose"
                        onClick={() => removeCoPassenger(pax.id)}
                      >
                        <i className="fa-regular fa-circle-xmark"></i>
                      </button>
                    )}

                    <h5 className="sectionTitle">
                      <span className="sectionTitleIcon goldIcon">
                        <i className="fa-solid fa-person-walking-luggage"></i>
                      </span>

                      {index > 0 ? "Co-Passenger" : "Main Passenger"}

                      {passengerPaid && (
                        <span className="badge bg-success ms-2">
                          <i className="fa-solid fa-lock me-1"></i>
                          Paid & Locked
                        </span>
                      )}
                    </h5>

                    <div className="row heightSame">
                      <div className="formHere mb-3 col-md-6">
                        <label>
                          {index === 0
                            ? "Select Main Passenger from Saved List"
                            : "Select Co-Passenger from Saved List"}
                        </label>
                        <select
                          className="form-control inputBoxIn forminput w-100"
                          value={passengerTraveler[pax.id] || ""}
                          onChange={(e) =>
                            handleSelectSavedPassenger(pax.id, e.target.value)
                          }
                        >
                          <option value="">-- Select Saved Passenger --</option>
                          {getAvailableSavedPassengers(pax.id).map((sp) => (
                            <option key={sp.id} value={sp.id}>
                              {sp.first_name} {sp.last_name} ({sp.email || ""})
                            </option>
                          ))}
                        </select>
                      </div>

                      {index > 0 && (
                        <>
                          <div
                            className="formHere mb-3 col-md-4"
                            data-error={`field-${pax.id}-relationship`}
                          >
                            <label>Relationship with Main Passenger</label>
                            <select
                              className="form-control inputBoxIn forminput w-100"
                              value={current.relationship || ""}
                              onChange={(e) =>
                                handlePassengerFieldChange(
                                  pax.id,
                                  "relationship",
                                  e.target.value,
                                )
                              }
                            >
                              <option value="">
                                -- Select Relationship --
                              </option>
                              <option value="friend">Friend</option>
                              <option value="brother">Brother</option>
                              <option value="sister">Sister</option>
                              <option value="wife">Wife</option>
                              <option value="husband">Husband</option>
                              <option value="son">Son</option>
                              <option value="daughter">Daughter</option>
                              <option value="father">Father</option>
                              <option value="mother">Mother</option>
                              <option value="colleague">Colleague</option>
                              <option value="other">Other</option>
                            </select>
                            {fieldErrors[pax.id]?.relationship && (
                              <small className="text-danger">
                                {fieldErrors[pax.id].relationship}
                              </small>
                            )}
                          </div>
                        </>
                      )}

                      {index === 0 && (
                        <>
                          <div
                            className="formHere mb-3 col-md-6"
                            data-error={`field-${pax.id}-travel_with`}
                          >
                            <label>I Want To Travel With (Optional)</label>
                            <input
                              type="text"
                              className="inputBoxIn form-control forminput w-100"
                              placeholder="Wallet Address"
                              value={current.travel_with || ""}
                              onChange={(e) =>
                                handlePassengerFieldChange(
                                  pax.id,
                                  "travel_with",
                                  e.target.value,
                                )
                              }
                            />
                            {fieldErrors[pax.id]?.travel_with && (
                              <small className="text-danger">
                                {fieldErrors[pax.id].travel_with}
                              </small>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="p-3 mb-4 rounded position-relative founderCard">
                    <h5 className="sectionTitle">
                      <span className="sectionTitleIcon blueIcon">
                        <i className="fa-solid fa-user"></i>
                      </span>
                      Basic Information
                    </h5>
                    <div className="row heightSame">
                      <div
                        className="formHere mb-3 col-md-4"
                        data-error={`field-${pax.id}-firstName`}
                      >
                        <label>First Name As Per Passport</label>
                        <input
                          type="text"
                          className="inputBoxIn form-control forminput w-100"
                          placeholder="John"
                          value={current.firstName || ""}
                          onChange={(e) =>
                            handlePassengerFieldChange(
                              pax.id,
                              "firstName",
                              e.target.value,
                            )
                          }
                        />
                        {fieldErrors[pax.id]?.firstName && (
                          <small className="text-danger">
                            {fieldErrors[pax.id].firstName}
                          </small>
                        )}
                      </div>
                      <div
                        className="formHere mb-3 col-md-4"
                        data-error={`field-${pax.id}-lastName`}
                      >
                        <label>Last Name As Per Passport</label>
                        <input
                          type="text"
                          className="inputBoxIn form-control forminput w-100"
                          placeholder="Doe"
                          value={current.lastName || ""}
                          onChange={(e) =>
                            handlePassengerFieldChange(
                              pax.id,
                              "lastName",
                              e.target.value,
                            )
                          }
                        />
                        {fieldErrors[pax.id]?.lastName && (
                          <small className="text-danger">
                            {fieldErrors[pax.id].lastName}
                          </small>
                        )}
                      </div>
                      <div
                        className="formHere mb-3 col-md-4"
                        data-error={`field-${pax.id}-email`}
                      >
                        <label>Email Address</label>
                        <input
                          type="text"
                          className="inputBoxIn form-control forminput w-100"
                          placeholder="tbc@gmail.com"
                          value={current.email || ""}
                          onChange={(e) =>
                            handlePassengerFieldChange(
                              pax.id,
                              "email",
                              e.target.value,
                            )
                          }
                        />
                        {fieldErrors[pax.id]?.email && (
                          <small className="text-danger">
                            {fieldErrors[pax.id].email}
                          </small>
                        )}
                      </div>
                    </div>

                    <div className="row heightSame">
                      <div
                        className="formHere mb-3 col-md-4"
                        data-error={`field-${pax.id}-gender`}
                      >
                        <label>Gender</label>
                        <select
                          className="inputBoxIn form-control forminput w-100"
                          value={current.gender || ""}
                          onChange={(e) =>
                            handlePassengerFieldChange(
                              pax.id,
                              "gender",
                              e.target.value,
                            )
                          }
                        >
                          <option value="">-- Select Gender --</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                        {fieldErrors[pax.id]?.gender && (
                          <small className="text-danger">
                            {fieldErrors[pax.id].gender}
                          </small>
                        )}
                      </div>
                      <div
                        className="formHere mb-3 col-md-4"
                        data-error={`field-${pax.id}-date_of_birth`}
                      >
                        <label>Date Of Birth</label>
                        <DatePickerField
                          className="inputBoxIn form-control forminput w-100"
                          label="Date Of Birth"
                          value={current.date_of_birth || ""}
                          onChange={(val) =>
                            handlePassengerFieldChange(
                              pax.id,
                              "date_of_birth",
                              val,
                            )
                          }
                        />
                        {fieldErrors[pax.id]?.date_of_birth && (
                          <small className="text-danger">
                            {fieldErrors[pax.id].date_of_birth}
                          </small>
                        )}
                      </div>
                      <div
                        className="formHere mb-3 col-md-4"
                        data-error={`field-${pax.id}-place_of_birth`}
                      >
                        <label>Place Of Birth</label>
                        <input
                          type="text"
                          className="inputBoxIn form-control forminput w-100"
                          placeholder="Place Of Birth"
                          value={current.place_of_birth || ""}
                          onChange={(e) =>
                            handlePassengerFieldChange(
                              pax.id,
                              "place_of_birth",
                              e.target.value,
                            )
                          }
                        />
                        {fieldErrors[pax.id]?.place_of_birth && (
                          <small className="text-danger">
                            {fieldErrors[pax.id].place_of_birth}
                          </small>
                        )}
                      </div>
                    </div>

                    <div className="row heightSame">
                      <div
                        className="formHere mb-3 col-md-4"
                        data-error={`field-${pax.id}-date_of_issue`}
                      >
                        <label>Date Of Passport Issuance</label>
                        <DatePickerField
                          className="inputBoxIn form-control forminput w-100"
                          label="Date Of Issue"
                          value={current.date_of_issue || ""}
                          onChange={(val) =>
                            handlePassengerFieldChange(
                              pax.id,
                              "date_of_issue",
                              val,
                            )
                          }
                          minDate={current.date_of_birth || ""}
                          maxDate={new Date()}
                        />
                        {fieldErrors[pax.id]?.date_of_issue && (
                          <small className="text-danger">
                            {fieldErrors[pax.id].date_of_issue}
                          </small>
                        )}
                      </div>
                      <div
                        className="formHere mb-3 col-md-4"
                        data-error={`field-${pax.id}-date_of_expiry`}
                      >
                        <label>Date Of Expiry Of Passport</label>
                        <DatePickerField
                          className="inputBoxIn form-control forminput w-100"
                          label="Date Of Expiry"
                          value={current.date_of_expiry || ""}
                          onChange={(val) =>
                            handlePassengerFieldChange(
                              pax.id,
                              "date_of_expiry",
                              val,
                            )
                          }
                          minDate={current.date_of_issue || undefined}
                        />
                        {fieldErrors[pax.id]?.date_of_expiry && (
                          <small className="text-danger">
                            {fieldErrors[pax.id].date_of_expiry}
                          </small>
                        )}
                      </div>
                      <div
                        className="formHere mb-3 col-md-4"
                        data-error={`field-${pax.id}-place_of_issue`}
                      >
                        <label>Place Of Issue</label>
                        <input
                          type="text"
                          className="inputBoxIn form-control forminput w-100"
                          placeholder="Place Of Issue"
                          value={current.place_of_issue || ""}
                          onChange={(e) =>
                            handlePassengerFieldChange(
                              pax.id,
                              "place_of_issue",
                              e.target.value,
                            )
                          }
                        />
                        {fieldErrors[pax.id]?.place_of_issue && (
                          <small className="text-danger">
                            {fieldErrors[pax.id].place_of_issue}
                          </small>
                        )}
                      </div>
                    </div>

                    <div className="row heightSame">
                      <div
                        className="formHere mb-3 col-md-4"
                        data-error={`field-${pax.id}-phone`}
                      >
                        <label>Phone No. With Country Code</label>
                        <input
                          type="text"
                          className="inputBoxIn form-control forminput w-100"
                          placeholder="+91 9876543210"
                          value={current.phone || ""}
                          onChange={(e) =>
                            handlePassengerFieldChange(
                              pax.id,
                              "phone",
                              e.target.value,
                            )
                          }
                        />
                        {fieldErrors[pax.id]?.phone && (
                          <small className="text-danger">
                            {fieldErrors[pax.id].phone}
                          </small>
                        )}
                      </div>
                      <div
                        className="formHere mb-3 col-md-4"
                        data-error={`field-${pax.id}-nationality`}
                      >
                        <label>Nationality</label>
                        <select
                          className="inputBoxIn form-control forminput w-100"
                          value={current.nationality || ""}
                          onChange={(e) =>
                            handlePassengerFieldChange(
                              pax.id,
                              "nationality",
                              e.target.value,
                            )
                          }
                        >
                          <option value="">-- Select Country --</option>

                          {countries.map((c) => (
                            <option key={c.alpha2Code} value={c.name}>
                              {c.name}
                            </option>
                          ))}
                        </select>

                        {fieldErrors[pax.id]?.nationality && (
                          <small className="text-danger">
                            {fieldErrors[pax.id].nationality}
                          </small>
                        )}
                      </div>
<div
  className="formHere mb-3 col-md-4"
  data-error={`field-${pax.id}-departure_airport_id`}
>
  <label>Near By Airport</label>

  <select
    className="inputBoxIn form-control forminput w-100"
    value={current.departure_airport_id || ""}
    onChange={(e) =>
      handlePassengerFieldChange(
        pax.id,
        "departure_airport_id",
        e.target.value,
      )
    }
    disabled={passengerPaid}
  >
    <option value="">Select Near By Airport</option>

    {airports.map((airport) => (
      <option key={airport.id} value={airport.id}>
        {airport.name} ({airport.iata_code || airport.code}) - {airport.city}
      </option>
    ))}
  </select>

  {fieldErrors[pax.id]?.departure_airport_id && (
    <small className="text-danger">
      {fieldErrors[pax.id].departure_airport_id}
    </small>
  )}
</div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-3">
                      <div className="p-3 mb-4 rounded position-relative founderCard">
                        <h5 className="sectionTitle">
                          <span className="sectionTitleIcon greenIcon">
                            <i className="fa-solid fa-image"></i>
                          </span>
                          Photo
                        </h5>
                        <div className="row heightSame">
                          <div
                            className="formHere mb-3 "
                            data-error={`photo-${pax.id}`}
                          >
                            <label>Passport Size Photo</label>

                            <div
                              className="upload-box upload-btn-wrapper"
                              onClick={() =>
                                document
                                  .getElementById(`fileInput-${pax.id}`)
                                  .click()
                              }
                              style={{ cursor: "pointer" }}
                            >
                              {photos[pax.id]?.preview && (
                                <div className="editHere">
                                  <img
                                    src={photos[pax.id].preview}
                                    alt="Passport size"
                                    style={{
                                      display: "block",
                                      height: "230px",
                                      borderRadius: "8px",
                                      border: "1px solid #ccc",
                                      marginBottom: "5px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>
                              )}
                              <div className="relative">
                                <div>
                                  <div className="imageuploadTitle">
                                    Drag & Drop Passport Size Photo Here{" "}
                                  </div>
                                  <div style={{ color: "#898989" }}>
                                    Only JPG | PNG | JPEG{" "}
                                    {photos[pax.id]?.preview && (
                                      <i
                                        style={{ color: "#008000" }}
                                        className="fa-solid fa-circle-check"
                                      ></i>
                                    )}
                                  </div>
                                  <div
                                    style={{
                                      marginTop: "5px",
                                      fontSize: "12px",
                                      color: "#7fbfff",
                                    }}
                                  >
                                    (Or Click To Select Passport Size Photo)
                                  </div>
                                </div>

                                <input
                                  id={`fileInput-${pax.id}`}
                                  type="file"
                                  accept="image/*"
                                  onChange={(e) => handlePhotoChange(e, pax.id)}
                                />
                              </div>
                            </div>

                            {photoErrors[pax.id] && (
                              <small className="text-danger d-block">
                                {photoErrors[pax.id]}
                              </small>
                            )}
                            <p className="text-muted mb-0 mt-1">
                              Recommended: clear face, jpg/jpeg/png.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-9">
                      <div className="p-3 mb-4 rounded position-relative founderCard">
                        <h5 className="sectionTitle">
                          <span className="sectionTitleIcon purpleIcon">
                            <i className="fa-solid fa-file-lines"></i>
                          </span>
                          Documents
                        </h5>
                        <div className="row heightSame">
                          {documentType.map((doc) => {
                            const docId = doc.id;
                            const docName = doc.name || doc.document || "";
                            const config = getDocConfig(doc);
                            const paxDoc = previews[pax.id]?.[docId] || {};
                            const frontLoading =
                                    documentLoading[pax.id]?.[docId]?.front || false;

                                  const backLoading =
                                    documentLoading[pax.id]?.[docId]?.back || false;
                            const numberVal =
                              docNumbers[pax.id]?.[docId] !== undefined
                                ? docNumbers[pax.id][docId]
                                : "";

                            const age = calcAgeFromDob(
                              current.date_of_birth || pax.date_of_birth,
                            );
                            const isMinor = age !== null && age < 18;

                            if (
                              shouldSkipDoc(
                                docId,
                                docName,
                                isMinor,
                                current.nationality,
                              )
                            )
                              return null;

                            return (
                              <div
                                className={`col-md-6 colManage ${docName.replace(/\s+/g, "-")}`}
                                key={docId}
                              >
                                <div className="formHere mb-3">
                                  {docName !== "Last 3 Years ITR" && (
                                    <div
                                      className="labelInput"
                                      data-error={`doc-${pax.id}-${docId}`}
                                    >
                                      <label>{docName} Number</label>
                                      <input
                                        type="text"
                                        className="inputBoxIn form-control forminput w-100"
                                        placeholder={`Enter ${docName} Number`}
                                        value={numberVal}
                                        onChange={(e) =>
                                          handleDocNumberChange(
                                            pax.id,
                                            docId,
                                            e.target.value,
                                          )
                                        }
                                      />
                                      {docErrors[pax.id]?.[docId]?.number && (
                                        <small className="text-danger">
                                          {docErrors[pax.id][docId].number}
                                        </small>
                                      )}
                                    </div>
                                  )}
                                  <div className="row">
                                    {config.front && (
                                      <div
                                        className={
                                          !config.back
                                            ? "col-sm-12 mt-2"
                                            : "col-sm-6 mt-2"
                                        }
                                      >
                                        <label>
                                          {config.pdf
                                            ? `${docName} (PDF Upload)`
                                            : `${docName} Front Side`}
                                        </label>

                                        <div
                                          className="relative upload-box"
                                          style={{
                                            height:
                                              docName !== "Last 3 Years ITR"
                                                ? "180px"
                                                : "253px",
                                          }}
                                        >
                                          {frontLoading && (
                                              <div className="documentLoader">
                                                <div className="spinner-border" role="status"></div>
                                                <span>Loading document...</span>
                                              </div>
                                            )}
                                          {!frontLoading &&
                                          paxDoc.front &&
                                            !paxDoc.front.isPdf &&
                                            paxDoc.front.preview && (
                                              <div className="editHere">
                                                <img
                                                  src={paxDoc.front.preview}
                                                  alt={`${docName} front`}
                                                  style={{
                                                    display: "block",
                                                    maxWidth: "100%",
                                                    height: "230px",
                                                    borderRadius: "10px",
                                                  }}
                                                />
                                              </div>
                                            )}
                                          {!frontLoading &&
                                          paxDoc.front &&
                                            paxDoc.front.isPdf &&
                                            paxDoc.front.preview && (
                                              <div className="editHere">
                                                <iframe
                                                  title="doc"
                                                  src={paxDoc.front.preview}
                                                  style={{
                                                    display: "block",
                                                    maxWidth: "100%",
                                                    height: "230px",
                                                    borderRadius: "10px",
                                                  }}
                                                ></iframe>
                                              </div>
                                            )}
                                          <div
                                            className="upload-btn-wrapper  relative"
                                            onClick={() =>
                                              document
                                                .getElementById(
                                                  `fileInput-${pax.id}-${docId}-front`,
                                                )
                                                .click()
                                            }
                                            style={{
                                              cursor: "pointer",
                                              textAlign: "center",
                                            }}
                                          >
                                            <div className="imageuploadTitle">
                                              Drag & Drop{" "}
                                              {config.pdf
                                                ? `${docName}`
                                                : `${docName} Front`}{" "}
                                              Here{" "}
                                            </div>
                                            <div style={{ color: "#898989" }}>
                                              Only{" "}
                                              {config.pdf
                                                ? "PDF"
                                                : "JPG | PNG | JPEG"}
                                              {paxDoc.front &&
                                                paxDoc.front.isPdf &&
                                                paxDoc.front.preview && (
                                                  <i
                                                    style={{ color: "#008000" }}
                                                    className="fa-solid fa-circle-check"
                                                  ></i>
                                                )}
                                              {paxDoc.front &&
                                                !paxDoc.front.isPdf &&
                                                paxDoc.front.preview && (
                                                  <i
                                                    style={{ color: "#008000" }}
                                                    className="fa-solid fa-circle-check"
                                                  ></i>
                                                )}
                                            </div>
                                            <div
                                              style={{
                                                marginTop: "5px",
                                                fontSize: "12px",
                                                color: "#7fbfff",
                                              }}
                                            >
                                              (Or Click To Select{" "}
                                              {config.pdf
                                                ? `${docName}`
                                                : `${docName} Front`}
                                              )
                                            </div>
                                            {docName === "Last 3 Years ITR" && (
                                              <p
                                                style={{
                                                  margin: 0,
                                                  paddingTop: 5,
                                                }}
                                              >
                                                A single PDF file containing 3
                                                years’ data will be uploaded at
                                                once.
                                              </p>
                                            )}

                                            <input
                                              id={`fileInput-${pax.id}-${docId}-front`}
                                              type="file"
                                              accept={
                                                config.pdf
                                                  ? "application/pdf"
                                                  : "image/*"
                                              }
                                              style={{ opacity: "0" }}
                                              onChange={(e) =>
                                                handleFileChange(
                                                  e,
                                                  pax.id,
                                                  docId,
                                                  "front",
                                                )
                                              }
                                            />
                                          </div>
                                        </div>

                                        {paxDoc.front && paxDoc.front.isPdf && (
                                          <p className="mt-2 mb-0">
                                            Selected PDF:{" "}
                                            <strong>
                                              {paxDoc.front.file?.name ||
                                                "Existing File"}
                                            </strong>
                                          </p>
                                        )}
                                        {docErrors[pax.id]?.[docId]?.front && (
                                          <small className="text-danger d-block">
                                            {docErrors[pax.id][docId].front}
                                          </small>
                                        )}
                                      </div>
                                    )}

                                    {config.back && !config.pdf && (
                                      <div className="col-sm-6 mt-2">
                                        <div className="">
                                          <label>{docName} Back Side</label>

                                          <div className="upload-box relative">
                                            {backLoading && (
                                                  <div className="documentLoader">
                                                    <div className="spinner-border" role="status"></div>
                                                    <span>Loading document...</span>
                                                  </div>
                                                )}
                                            {!backLoading &&
                                            paxDoc.back &&
                                              paxDoc.back.preview && (
                                                <div className="editHere">
                                                  <img
                                                    src={paxDoc.back.preview}
                                                    alt={`${docName} back`}
                                                    style={{
                                                      display: "block",
                                                      maxWidth: "100%",
                                                      height: "230px",
                                                      borderRadius: "10px",
                                                    }}
                                                  />
                                                </div>
                                              )}
                                            <div className="upload-btn-wrapper  relative">
                                              <div className="imageuploadTitle">
                                                Drag & Drop {docName} Back Here
                                              </div>
                                              <div style={{ color: "#898989" }}>
                                                Only{" "}
                                                {config.pdf
                                                  ? "PDF"
                                                  : "JPG | PNG | JPEG"}
                                                {paxDoc.back &&
                                                  paxDoc.back.preview && (
                                                    <i
                                                      style={{
                                                        color: "#008000",
                                                      }}
                                                      className="fa-solid fa-circle-check"
                                                    ></i>
                                                  )}
                                              </div>
                                              <div
                                                style={{
                                                  marginTop: "5px",
                                                  fontSize: "12px",
                                                  color: "#7fbfff",
                                                }}
                                              >
                                                (Or Click To Select {docName}{" "}
                                                Back)
                                              </div>

                                              <input
                                                id={`fileInput-${pax.id}-${docId}-back`}
                                                type="file"
                                                accept="image/*"
                                                style={{ opacity: "0" }}
                                                onChange={(e) =>
                                                  handleFileChange(
                                                    e,
                                                    pax.id,
                                                    docId,
                                                    "back",
                                                  )
                                                }
                                              />
                                            </div>
                                          </div>
                                          {docErrors[pax.id]?.[docId]?.back && (
                                            <small className="text-danger d-block">
                                              {docErrors[pax.id][docId].back}
                                            </small>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              </fieldset>
            );
          })}

          <div className="d-flex justify-content-between flex-wrap gap-1">
            <div className="formHere mb-2 col-md-2 order-2 order-md-1">
              <button
                type="button"
                className="text-center mt-2 mybtn d-flex gap-2 align-items-center w-100 m-auto"
                onClick={handleSubmit}
              >
                <span className="bgIN">Submit</span>
              </button>
            </div>
            <div className="text-center mb-2 order-1 order-md-2">
              <button
                type="button"
                className="text-center mt-2 mybtn d-flex gap-2 align-items-center w-100 m-auto btn-primary"
                onClick={addCoPassenger}
                disabled={
                  !tourAccess.canAddPassenger ||
                  coPassengers.length >= maxPassengers
                }
              >
                <span className="bgIN">
                  {!tourAccess.canOpenDocuments
                    ? tourAccess.statusLabel || "Booking Unavailable"
                    : !applicationOpen
                      ? "Application Closed"
                      : !tourAccess.canAddPassenger ||
                          coPassengers.length >= maxPassengers
                        ? "Passenger Limit Reached"
                        : "+ Add Co-Passenger"}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DocumentsPage;